import React, { useState, useEffect } from 'react'
import { DetailModal } from './LocationModal'
import SpecialBadge, { IS_SPECIAL } from './SpecialBadge'

function sortRouteByDate(route) {
  const groups = new Map()
  const noTicket = []
  for (const seg of route) {
    if (!seg.ticket_id) { noTicket.push(seg); continue }
    if (!groups.has(seg.ticket_id)) groups.set(seg.ticket_id, [])
    groups.get(seg.ticket_id).push(seg)
  }
  const sorted = [...groups.values()].sort((a, b) => {
    const da = a.reduce((min, s) => s.from_date && s.from_date < min ? s.from_date : min, '9999')
    const db = b.reduce((min, s) => s.from_date && s.from_date < min ? s.from_date : min, '9999')
    return da < db ? -1 : da > db ? 1 : 0
  })
  return [...sorted.flat(), ...noTicket]
}
import { updateCandidate, addCandidate, deleteCandidate, fetchCandidateById, fetchUserProfiles, updateUserProfile, addTicket, updateTicket, fetchTicketById, fetchTickets, uploadRouteFile, fetchAgents, updateAgent, uploadAgentFile, fetchCities, fetchArchivedCandidates, fetchCompletedCandidates, fetchPartnerCompletedCandidates, getOrCreateGeoToken, getCandidateLocation, fetchAgentById, uploadNoteFile, fetchAgentCandidates, fetchTasks, addTask, updateTask, deleteTask, fetchCandidateTasks, fetchWhatsappHistory, fetchWhatsappChannels, sendWhatsappMessage, markWaRead, fetchAgentCountries, addAgentCountry, updateAgentCountry, fetchAgentAdvances, addAgentAdvance, deleteAgentAdvance, updateMoscowTask, fetchContractorExportStatus, downloadMyCandidatesExport } from '../lib/api'
import TemplatesPage from './TemplatesPage'
import StatementImport from './StatementImport'
import GeoMapModal from './GeoMapModal'

const DEFAULT_NS = {
  booking:   { enabled: true, advance_hours: [24, 12], repeat_hours: 0 },
  checkout:  { enabled: true, advance_hours: [24, 12], repeat_hours: 0 },
  departure: { enabled: true, advance_hours: [24, 12], repeat_hours: 0 },
  arrival:   { enabled: true, advance_hours: [24, 12], repeat_hours: 0 },
}

function NotificationSettings({ userProfile, onSaved }) {
  const init = { ...DEFAULT_NS, ...(userProfile?.notification_settings || {}) }
  const [ns, setNs] = useState(init)
  const [saving, setSaving] = useState(false)
  const [saved, setSaved] = useState(false)

  function toggleAdvance(type, h) {
    setNs(prev => {
      const cur = prev[type].advance_hours || []
      const next = cur.includes(h) ? cur.filter(x => x !== h) : [...cur, h].sort((a,b) => b-a)
      return { ...prev, [type]: { ...prev[type], advance_hours: next } }
    })
  }

  function setRepeat(type, v) {
    setNs(prev => ({ ...prev, [type]: { ...prev[type], repeat_hours: v } }))
  }

  function setEnabled(type, v) {
    setNs(prev => ({ ...prev, [type]: { ...prev[type], enabled: v } }))
  }

  async function handleSave() {
    setSaving(true)
    await updateUserProfile(userProfile.id, { notification_settings: ns })
    setSaving(false)
    setSaved(true)
    setTimeout(() => setSaved(false), 2000)
    if (onSaved) onSaved(ns)
  }

  const ADVANCE_OPTIONS = [48, 24, 12, 6, 2]
  const REPEAT_OPTIONS = [
    { label: 'Нет', value: 0 },
    { label: 'Каждые 2 ч', value: 2 },
    { label: 'Каждые 4 ч', value: 4 },
    { label: 'Каждые 6 ч', value: 6 },
    { label: 'Каждые 12 ч', value: 12 },
    { label: 'Каждые 24 ч', value: 24 },
  ]

  const TYPES = [
    { key: 'departure', label: '✈️ Вылет', desc: 'Уведомление перед датой вылета кандидата' },
    { key: 'arrival',   label: '🛬 Прилёт', desc: 'Уведомление перед датой прилёта кандидата' },
    { key: 'booking',   label: '🏨 Заезд в отель', desc: 'Уведомление перед датой заезда в отель' },
    { key: 'checkout',  label: '🚪 Выезд из отеля', desc: 'Уведомление перед датой выезда из отеля' },
  ]

  const cardStyle = { background: 'white', border: '1px solid #e8e8e5', borderRadius: 12, padding: '16px 18px', marginBottom: 12 }
  const chipStyle = (active) => ({
    fontSize: 12, padding: '5px 12px', borderRadius: 20, border: '1px solid',
    cursor: 'pointer', fontWeight: 500,
    background: active ? '#1a1a1a' : 'white',
    borderColor: active ? '#1a1a1a' : '#d0d0cc',
    color: active ? 'white' : '#555',
  })

  return (
    <div>
      <div style={{ fontSize: 13, color: '#888', marginBottom: 16 }}>
        Уведомления приходят в Telegram. Убедитесь что ваш Telegram подключён к боту.
      </div>

      {TYPES.map(({ key, label, desc }) => {
        const cfg = ns[key] || {}
        return (
          <div key={key} style={{ ...cardStyle, opacity: cfg.enabled === false ? 0.6 : 1 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
              <div>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{label}</div>
                <div style={{ fontSize: 12, color: '#999', marginTop: 2 }}>{desc}</div>
              </div>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                <span style={{ fontSize: 12, color: '#888' }}>{cfg.enabled !== false ? 'Вкл' : 'Выкл'}</span>
                <div onClick={() => setEnabled(key, cfg.enabled === false ? true : false)}
                  style={{ width: 36, height: 20, borderRadius: 10, background: cfg.enabled !== false ? '#1a1a1a' : '#ccc', position: 'relative', cursor: 'pointer', transition: 'background 0.2s' }}>
                  <div style={{ position: 'absolute', top: 2, left: cfg.enabled !== false ? 18 : 2, width: 16, height: 16, borderRadius: '50%', background: 'white', transition: 'left 0.2s' }} />
                </div>
              </label>
            </div>

            {cfg.enabled !== false && (
              <>
                <div style={{ fontSize: 12, color: '#555', fontWeight: 600, marginBottom: 8 }}>Уведомить заранее:</div>
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 14 }}>
                  {ADVANCE_OPTIONS.map(h => (
                    <button key={h} onClick={() => toggleAdvance(key, h)} style={chipStyle((cfg.advance_hours || []).includes(h))}>
                      за {h} ч
                    </button>
                  ))}
                </div>

                <div style={{ fontSize: 12, color: '#555', fontWeight: 600, marginBottom: 8 }}>Повторять напоминание:</div>
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                  {REPEAT_OPTIONS.map(opt => (
                    <button key={opt.value} onClick={() => setRepeat(key, opt.value)} style={chipStyle((cfg.repeat_hours || 0) === opt.value)}>
                      {opt.label}
                    </button>
                  ))}
                </div>
              </>
            )}
          </div>
        )
      })}

      <button onClick={handleSave} disabled={saving}
        style={{ padding: '9px 24px', background: saved ? '#2d7d46' : '#1a1a1a', color: 'white', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
        {saved ? '✓ Сохранено' : saving ? 'Сохранение...' : 'Сохранить настройки'}
      </button>
    </div>
  )
}

function BookingInlineSection({ candidates, locations, currentUserId, onRefresh, agents, canSeeAgents = true }) {
  const [search, setSearch] = useState('')
const [openId, setOpenId] = useState(null)
  const [openBookings, setOpenBookings] = useState({})
  const [form, setForm] = useState({ hotel: '', check_in: '', check_out: '', price: '', notes: '', expense_date: new Date().toISOString().split('T')[0] })
  const [saving, setSaving] = useState(false)
  const [bookingFile, setBookingFile] = useState(null)
  const [fromAgent, setFromAgent] = useState({ enabled: false, agent_source_id: '', agent_source_name: '' })

  const inputStyle = { width: '100%', fontSize: 13, padding: '6px 10px', borderRadius: 8, border: '1px solid #e0e0dc', boxSizing: 'border-box' }


  function closeBookingForm(candidateId) {
    if (openId === candidateId && (form.hotel || form.check_in || form.price)) {
      if (!window.confirm('Данные формы будут потеряны. Закрыть?')) return
    }
    setOpenId(openId === candidateId ? null : candidateId)
    setForm({ hotel: '', check_in: '', check_out: '', price: '', notes: '', expense_date: new Date().toISOString().split('T')[0] })
    setFromAgent({ enabled: false, agent_source_id: '', agent_source_name: '' })
  }

  async function handleSave(c) {
    if (!form.hotel || !form.check_in || !form.check_out) { alert('Заполните название отеля и даты'); return }
    if (form.price && parseFloat(form.price) > 0 && !form.expense_date) { alert('Добавьте дату расхода!'); return }
    setSaving(true)
    try {
   let fileData = null
      if (bookingFile) fileData = await uploadRouteFile(bookingFile, 'booking_' + c.id + '_' + Date.now(), 'booking')   
const newBooking = {
        hotel: form.hotel,
        check_in: form.check_in,
        check_out: form.check_out,
        price: form.price || 0,
        notes: form.notes,
        file: fileData,
        location_id: c.location_id,
        location_name: locations.find(l => l.id === c.location_id)?.name || ''
      }
      const freshC = await fetchCandidateById(c.id)
      const updatedBookings = [...(freshC.hotel_bookings || []), newBooking]
      const newExpense = {
        category: 'Отель/жильё',
        amount: parseFloat(form.price) || 0,
        date: form.expense_date || new Date().toISOString().split('T')[0],
        comment: 'Бронирование: ' + form.hotel + (form.check_in ? ' c ' + form.check_in.split('-').reverse().join('.') : '') + (form.check_out ? ' по ' + form.check_out.split('-').reverse().join('.') : ''),
        operator_id: currentUserId,
        location_id: c.location_id,
        location_name: locations.find(l => l.id === c.location_id)?.name || ''
      }
      const agentFields = fromAgent.enabled ? { from_agent: true, agent_source_id: fromAgent.agent_source_id, agent_source_name: fromAgent.agent_source_name, agent_amount: parseFloat(form.price) || 0 } : {}
      const expenseWithAgent = { ...newExpense, ...agentFields }
      const updatedExpenses = [...(freshC.expenses || []), expenseWithAgent]
      await updateCandidate(c.id, { hotel_bookings: updatedBookings, expenses: updatedExpenses })
      setForm({ hotel: '', check_in: '', check_out: '', price: '', notes: '', expense_date: new Date().toISOString().split('T')[0] })
      setBookingFile(null)
      setFromAgent({ enabled: false, agent_source_id: '', agent_source_name: '' })
      setOpenId(null)
      onRefresh()
    } catch (e) { alert('Ошибка: ' + e.message) }
    setSaving(false)
  }

  const filtered = candidates.filter(c => {
    if (!search) return true
    const q = search.toLowerCase()
    return c.name?.toLowerCase().includes(q) || c.passport?.toLowerCase().includes(q)
  }).sort((a, b) => (b.hotel_bookings || []).length - (a.hotel_bookings || []).length)

  return (
    <div>
      <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Поиск по имени или паспорту..." style={{ ...inputStyle, marginBottom: 12 }} />
      {filtered.map(c => {
        const bookings = c.hotel_bookings || []
        return (
          <div key={c.id} style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 10, marginBottom: 8, overflow: 'hidden' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 14px' }}>
              <div>
                <span style={{ fontWeight: 500, fontSize: 13 }}>{c.name}</span>
                <span style={{ color: '#aaa', fontSize: 11, marginLeft: 8 }}>{locations.find(l => l.id === c.location_id)?.name || '—'}</span>
{bookings.length > 0 && <span onClick={() => setOpenBookings(prev => ({ ...prev, [c.id]: !prev[c.id] }))} style={{ fontSize: 11, color: '#378ADD', marginLeft: 8, cursor: 'pointer' }}>🏨 {bookings.length} броней {openBookings[c.id] ? '▲' : '▼'}</span>}
              </div>
              <button onClick={() => closeBookingForm(c.id)} style={{ fontSize: 12, padding: '4px 10px', borderRadius: 6, border: 'none', background: openId === c.id ? '#e8e8e5' : '#1a1a1a', color: openId === c.id ? '#444' : 'white', cursor: 'pointer' }}>
                {openId === c.id ? 'Закрыть' : '+ Бронирование'}
              </button>
            </div>
            {bookings.length > 0 && openBookings[c.id] && (
              <div style={{ padding: '0 14px 10px', borderTop: '1px solid #f5f5f3' }}>
                {bookings.map((b, i) => (
                  <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', fontSize: 12, padding: '4px 0', borderBottom: '0.5px solid #f5f5f3' }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ color: '#444' }}>🏨 {b.hotel || b.hotel_name || '—'}</div>
                      <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginTop: 2, flexWrap: 'wrap' }}>
                        <span style={{ color: '#888', fontSize: 11 }}>{b.check_in ? b.check_in.split('-').reverse().join('.') : ''} — {b.check_out ? b.check_out.split('-').reverse().join('.') : ''}</span>
                        {b.price > 0 && <span style={{ color: '#378ADD', fontSize: 11, fontWeight: 600 }}>{parseFloat(b.price).toLocaleString('ru-RU')} ₽</span>}
                        {b.file && <a href={b.file.url} target="_blank" rel="noreferrer" style={{ fontSize: 11, color: '#185FA5', textDecoration: 'none' }}>📎 {b.file.name}</a>}
                      </div>
                      {b.notes && <div style={{ color: '#888', fontSize: 11, marginTop: 2, fontStyle: 'italic' }}>💬 {b.notes}</div>}
                    </div>
                    <button onClick={async () => {
                      if (!window.confirm('Удалить бронирование?')) return
                      const b = bookings[i]
                      const freshC2 = await fetchCandidateById(c.id)
                      const updated = (freshC2.hotel_bookings || []).filter((_, j) => j !== i)
                      const upd = { hotel_bookings: updated }
                      if (parseFloat(b?.price) > 0) {
                        const bd = s => s ? s.split('-').reverse().join('.') : ''
                        const expComment = 'Бронирование: ' + b.hotel + (b.check_in ? ' c ' + bd(b.check_in) : '') + (b.check_out ? ' по ' + bd(b.check_out) : '')
                        upd.expenses = (freshC2.expenses || []).filter(e => !(['Отель/жильё', 'Отель / жильё'].includes(e.category) && e.comment === expComment))
                      }
                      await updateCandidate(c.id, upd)
                      onRefresh()
                    }} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ccc', fontSize: 14, lineHeight: 1, padding: '0 2px', flexShrink: 0 }} title="Удалить">✕</button>
                  </div>
                ))}
              </div>
            )}
            {openId === c.id && (
              <div style={{ padding: '0 14px 14px', borderTop: '1px solid #f0f0ec' }}>
                <div style={{ marginTop: 10, marginBottom: 8 }}>
                  <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Название отеля</div>
                  <input value={form.hotel} onChange={e => setForm(f => ({ ...f, hotel: e.target.value }))} placeholder="Название и адрес" style={inputStyle} />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
                  <div>
                    <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Заезд</div>
                    <input type="date" value={form.check_in} onChange={e => setForm(f => ({ ...f, check_in: e.target.value }))} style={inputStyle} />
                  </div>
                  <div>
                    <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Выезд</div>
                    <input type="date" value={form.check_out} onChange={e => setForm(f => ({ ...f, check_out: e.target.value }))} style={inputStyle} />
                  </div>
                  <div>
                    <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Стоимость (₽)</div>
                    <input type="text" inputMode="numeric" value={form.price} onChange={e => setForm(f => ({ ...f, price: e.target.value.replace(/[^0-9.]/g, '') }))} placeholder="0" style={inputStyle} />
                  </div>
                  <div>
                    <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Дата расхода</div>
                    <input type="date" value={form.expense_date} onChange={e => setForm(f => ({ ...f, expense_date: e.target.value }))} style={inputStyle} />
                  </div>
                  <div style={{ gridColumn: '1 / -1' }}>
                    <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Примечание</div>
                    <input value={form.notes} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} style={inputStyle} />
                  </div>
                </div>
                <div style={{ marginBottom: 10 }}>
                  <label style={{ display: 'inline-block', fontSize: 12, padding: '6px 12px', border: '1px dashed #d0d0cc', borderRadius: 7, cursor: 'pointer', color: '#888' }}>
                    📎 {bookingFile ? bookingFile.name : 'Прикрепить файл бронирования'}
                    <input type="file" accept="image/*,.pdf" onChange={e => setBookingFile(e.target.files[0])} style={{ display: 'none' }} />
                  </label>
                </div>
<button onClick={() => handleSave(c)} disabled={saving} style={{ fontSize: 13, padding: '8px 20px', borderRadius: 8, border: 'none', background: '#1a1a1a', color: 'white', cursor: 'pointer', fontWeight: 600 }}>
                  {saving ? 'Сохранение...' : 'Сохранить бронирование'}
                </button>
                {canSeeAgents && <div style={{ marginTop: 10 }}>
                  <label style={{ display: 'inline-flex', alignItems: 'center', gap: 7, fontSize: 13, cursor: 'pointer', userSelect: 'none' }}>
                    <input type="checkbox" checked={!!fromAgent.enabled} onChange={e => setFromAgent({ enabled: e.target.checked, agent_source_id: '', agent_source_name: '' })} />
                    <span style={{ fontWeight: 500, color: fromAgent.enabled ? '#c07840' : '#555' }}>🤝 Расход от агента</span>
                  </label>
                  {fromAgent.enabled && (
                    <div style={{ marginTop: 8 }}>
                      <select value={fromAgent.agent_source_id} onChange={e => {
                        const ag = (agents || []).find(a => a.id === e.target.value)
                        setFromAgent(f => ({ ...f, agent_source_id: e.target.value, agent_source_name: ag?.name || '' }))
                      }} style={{ width: '100%', fontSize: 13, padding: '6px 10px', borderRadius: 8, border: '1px solid #f0c080', background: '#fffbf0', boxSizing: 'border-box' }}>
                        <option value="">— выбрать агента —</option>
                        {(agents || []).map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
                      </select>
                    </div>
                  )}
                </div>}
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}
function TripInlineSection({ candidates, locations, currentUserId, currentUserName, onSaved, agents, canSeeAgents = true }) {  const [search, setSearch] = useState('')
  const [openTrips, setOpenTrips] = useState({})
const [openId, setOpenId] = useState(null)
  const [editRouteIdx, setEditRouteIdx] = useState(null) // {candidateId, routeIdx}
  const [cities, setCities] = useState([])
  const [transportType, setTransportType] = useState('автобус') // 'авиа' | 'автобус'
  const [segments, setSegments] = useState([{ from: '', from_tz: 'Africa/Harare', to: '', to_tz: 'Africa/Harare', departure_date: '', departure_time: '', arrival_date: '', arrival_time: '' }])
  const [ticketNumber, setTicketNumber] = useState('')
  const [price, setPrice] = useState('')
  const [airline, setAirline] = useState('')
  const [aggregator, setAggregator] = useState('')
  const [paymentMethod, setPaymentMethod] = useState('')
  const [addToRegistry, setAddToRegistry] = useState(true)
  const [isReturn, setIsReturn] = useState(false)
  const [purchaseDate, setPurchaseDate] = useState(new Date().toISOString().split('T')[0])
  const [tripFile, setTripFile] = useState(null)
  const [tripComment, setTripComment] = useState('')
  const [saving, setSaving] = useState(false)
  const [deletingFile, setDeletingFile] = useState(null) // 'candidateId_pointIdx_fileIdx'
  const [fromAgent, setFromAgent] = useState({ enabled: false, agent_source_id: '', agent_source_name: '' })

  function hasTripData() {
    const seg = segments[0]
    return !!(seg.from || seg.to || seg.departure_date || ticketNumber || price || airline)
  }
  function closeTripForm(candidateId) {
    if (openId === candidateId && hasTripData()) {
      if (!window.confirm('Данные формы будут потеряны. Закрыть?')) return
    }
    setOpenId(openId === candidateId ? null : candidateId)
    setSegments([{ from: '', from_tz: 'Africa/Harare', to: '', to_tz: 'Africa/Harare', departure_date: '', departure_time: '', arrival_date: '', arrival_time: '' }])
    setTicketNumber(''); setPrice(''); setAirline(''); setAggregator(''); setPaymentMethod('')
    setAddToRegistry(false); setIsReturn(false); setTransportType('автобус')
    setPurchaseDate(new Date().toISOString().split('T')[0]); setTripComment(''); setEditRouteIdx(null)
    setFromAgent({ enabled: false, agent_source_id: '', agent_source_name: '' })
  }

  useEffect(() => { fetchCities().then(setCities).catch(() => {}) }, [])

  const TIMEZONES = [
    { label: 'Гватемала (UTC-6)', value: 'America/Guatemala' },
    { label: 'Богота / Лима (UTC-5)', value: 'America/Bogota' },
    { label: 'Каракас (UTC-4)', value: 'America/Caracas' },
    { label: 'Буэнос-Айрес (UTC-3)', value: 'America/Argentina/Buenos_Aires' },
    { label: 'Бразилиа (UTC-3)', value: 'America/Sao_Paulo' },
    { label: 'Кабо-Верде (UTC-1)', value: 'Atlantic/Cape_Verde' },
    { label: 'Лондон (UTC+0/+1)', value: 'Europe/London' },
    { label: 'Лагос / Луанда (UTC+1)', value: 'Africa/Lagos' },
    { label: 'Берлин / Париж (UTC+1/+2)', value: 'Europe/Berlin' },
    { label: 'Каир (UTC+2)', value: 'Africa/Cairo' },
    { label: 'Харare / Йоханнесбург (UTC+2)', value: 'Africa/Harare' },
    { label: 'Найроби / Аддис-Абеба (UTC+3)', value: 'Africa/Nairobi' },
    { label: 'Москва (UTC+3)', value: 'Europe/Moscow' },
    { label: 'Стамбул (UTC+3)', value: 'Europe/Istanbul' },
    { label: 'Дубай / Маскат (UTC+4)', value: 'Asia/Dubai' },
    { label: 'Карачи (UTC+5)', value: 'Asia/Karachi' },
    { label: 'Дели (UTC+5:30)', value: 'Asia/Kolkata' },
    { label: 'Дакка (UTC+6)', value: 'Asia/Dhaka' },
    { label: 'Бангкок / Джакарта (UTC+7)', value: 'Asia/Bangkok' },
    { label: 'Манила / Пекин (UTC+8)', value: 'Asia/Manila' },
    { label: 'Токио / Сеул (UTC+9)', value: 'Asia/Tokyo' },
    { label: 'Порт-Морсби (UTC+10)', value: 'Pacific/Port_Moresby' },
    { label: 'Сидней (UTC+10/+11)', value: 'Australia/Sydney' },
  ]

  function setSeg(idx, field, value) {
    setSegments(segs => segs.map((s, i) => i === idx ? { ...s, [field]: value } : s))
  }

  function addSegment() {
    setSegments(segs => {
      const last = segs[segs.length - 1]
      return [...segs, { from: last.to, from_tz: last.to_tz, to: '', to_tz: last.to_tz, departure_date: '', departure_time: '', arrival_date: '', arrival_time: '' }]
    })
  }
  function removeSegment(idx) { setSegments(segs => segs.filter((_, i) => i !== idx)) }

  async function handleStartEdit(c, routeIdx) {
    const route = Array.isArray(c.route) ? c.route : []
    const p = route[routeIdx]
    if (!p) return
    setOpenId(c.id)
    setEditRouteIdx({ candidateId: c.id, routeIdx })
    setTransportType(p.transport_type || (p.note?.includes('Автобус') ? 'автобус' : 'авиа'))
    setIsReturn(p.is_return || p.note?.includes('обратный') || false)
    setTripComment(p.comment || '')
    setTripFile(null)
    setAddToRegistry(!!p.ticket_id)
    setOpenTrips(prev => ({ ...prev, [c.id]: false }))
    // Загружаем все сегменты билета (по ticket_id)
    if (p.ticket_id) {
      const relatedPoints = route.filter(r => r.ticket_id === p.ticket_id)
      const loadedSegments = relatedPoints.length > 0
        ? relatedPoints.map(r => ({ from: r.from || '', from_tz: r.from_tz || 'Africa/Harare', to: r.to || '', to_tz: r.to_tz || 'Africa/Harare', departure_date: r.from_date || '', departure_time: r.from_time || '', arrival_date: r.to_date || '', arrival_time: r.to_time || '' }))
        : [{ from: p.from || '', from_tz: p.from_tz || 'Africa/Harare', to: p.to || '', to_tz: p.to_tz || 'Africa/Harare', departure_date: p.from_date || '', departure_time: p.from_time || '', arrival_date: p.to_date || '', arrival_time: p.to_time || '' }]
      setSegments(loadedSegments)
      try {
        const t = await fetchTicketById(p.ticket_id)
        setTicketNumber(t.ticket_number || '')
        setPrice(t.price ? String(t.price) : '')
        setAirline(t.airline || '')
        setAggregator(t.aggregator || '')
        setPaymentMethod(t.payment_method || '')
        setPurchaseDate(t.purchase_date ? String(t.purchase_date).slice(0, 10) : new Date().toISOString().split('T')[0])
        if (t.comment) setTripComment(t.comment)
      } catch { setTicketNumber(''); setPrice(''); setAirline(''); setAggregator(''); setPaymentMethod(''); setPurchaseDate(new Date().toISOString().split('T')[0]) }
    } else {
      setSegments([{ from: p.from || '', from_tz: p.from_tz || 'Africa/Harare', to: p.to || '', to_tz: p.to_tz || 'Africa/Harare', departure_date: p.from_date || '', departure_time: p.from_time || '', arrival_date: p.to_date || '', arrival_time: p.to_time || '' }])
      setTicketNumber(''); setPrice(''); setAirline(''); setAggregator(''); setPaymentMethod(''); setPurchaseDate(new Date().toISOString().split('T')[0])
    }
  }

  async function handleSave(c) {
    const firstSeg = segments[0]
    if (!firstSeg.from || !firstSeg.to || !firstSeg.departure_date) { alert('Заполните первый сегмент: откуда, куда, дату'); return }
    setSaving(true)
    try {
      let fileData = null
      if (tripFile) fileData = await uploadRouteFile(tripFile, 'ticket_' + c.id + '_' + Date.now(), 'ticket')

      const isBus = transportType === 'автобус'
      const shouldAddToRegistry = !isBus && (addToRegistry || isReturn)

      let ticketId = null
      const isEditing = !!(editRouteIdx && editRouteIdx.candidateId === c.id)
      const oldPoint0 = isEditing ? (Array.isArray(c.route) ? c.route : [])[editRouteIdx.routeIdx] || {} : {}

      const ticketPayload = {
        from_city: firstSeg.from, from_tz: firstSeg.from_tz,
        to_city: segments[segments.length - 1].to, to_tz: segments[segments.length - 1].to_tz,
        departure_date: firstSeg.departure_date, departure_time: firstSeg.departure_time || null,
        arrival_date: segments[segments.length - 1].arrival_date || null,
        arrival_time: segments[segments.length - 1].arrival_time || null,
        ticket_number: ticketNumber || null, price: price ? parseFloat(price) : 0,
        airline: airline || null, aggregator: aggregator || null,
        payment_method: paymentMethod || null,
        purchase_date: purchaseDate || null,
        segments: segments,
      }

      if (isEditing && oldPoint0.ticket_id) {
        // Обновляем существующий билет
        await updateTicket(oldPoint0.ticket_id, ticketPayload)
        ticketId = oldPoint0.ticket_id
      } else if (isEditing && !oldPoint0.ticket_id && shouldAddToRegistry) {
        // Редактируем точку без билета — создаём запись в реестре
        const savedTicket = await addTicket({
          candidate_id: c.id, type: isBus ? 'автобус' : isReturn ? 'обратный' : 'авиа',
          purchased_by: currentUserName, ...ticketPayload,
        })
        ticketId = savedTicket.id
      } else if (!isEditing && shouldAddToRegistry) {
        const savedTicket = await addTicket({
          candidate_id: c.id, type: isBus ? 'автобус' : isReturn ? 'обратный' : 'авиа',
          purchased_by: currentUserName, ...ticketPayload,
        })
        ticketId = savedTicket.id
      }

      const routeNote = isBus
        ? 'Автобус' + (segments.length > 1 ? ' (сегмент {i+1} из ' + segments.length + ')' : '')
        : 'Авиабилет'
      const newRoutePoints = segments.filter(s => s.from && s.to).map((s, i) => ({
        from: s.from, from_tz: s.from_tz, from_date: s.departure_date, from_time: s.departure_time,
        to: s.to, to_tz: s.to_tz, to_date: s.arrival_date || s.departure_date, to_time: s.arrival_time,
        note: isBus ? 'Автобус' + (segments.length > 1 ? ' (сегмент ' + (i+1) + ' из ' + segments.length + ')' : '') : 'Авиабилет' + (segments.length > 1 ? ' (сегмент ' + (i+1) + ' из ' + segments.length + ')' : ''),
        files: fileData ? [fileData] : [], ticket_id: ticketId,
        transport_type: transportType,
        is_return: isReturn || false,
        comment: tripComment || null,
      }))

      const freshCandidate = await fetchCandidateById(c.id)

      if (isEditing) {
        // Редактирование существующей точки
        const fullRoute = [...(freshCandidate.route || [])]
        const oldPoint = fullRoute[editRouteIdx.routeIdx] || {}
        const resolvedTicketId = ticketId || oldPoint.ticket_id || null
        const existingFiles = fileData ? [...(oldPoint.files || []), fileData] : (oldPoint.files || [])
        // Строим новые точки для всех сегментов
        const editedPoints = segments.filter(s => s.from && s.to).map((s, i) => ({
          from: s.from, from_tz: s.from_tz, from_date: s.departure_date, from_time: s.departure_time,
          to: s.to, to_tz: s.to_tz, to_date: s.arrival_date || s.departure_date, to_time: s.arrival_time,
          note: isBus ? 'Автобус' + (segments.length > 1 ? ' (сегмент ' + (i+1) + ' из ' + segments.length + ')' : '') : 'Авиабилет' + (segments.length > 1 ? ' (сегмент ' + (i+1) + ' из ' + segments.length + ')' : ''),
          files: existingFiles,
          ticket_id: resolvedTicketId,
          transport_type: transportType,
          is_return: isReturn || false,
          comment: tripComment || null,
        }))
        // Удаляем все старые точки этого билета, вставляем новые на их место
        const otherPoints = fullRoute.filter((p, idx) => {
          if (resolvedTicketId) return p.ticket_id !== resolvedTicketId
          return idx !== editRouteIdx.routeIdx
        })
        const updatedRoute = sortRouteByDate([...otherPoints, ...editedPoints])
        // Обновляем расход если цена изменилась
        const lastSeg2 = segments[segments.length - 1]
        const updatedExpenses = (freshCandidate.expenses || []).map(e => {
          if (e.ticket_id && e.ticket_id === (ticketId || oldPoint0.ticket_id)) {
            return {
              ...e,
              amount: price ? parseFloat(price) : e.amount,
              comment: (isBus ? 'Автобус' : isReturn ? 'Обратный билет' : 'Билет') + ': ' + firstSeg.from + ' → ' + lastSeg2.to + (airline ? ' (' + airline + ')' : '') + (ticketNumber ? ' №' + ticketNumber : '') + (tripComment ? ' | ' + tripComment : ''),
            }
          }
          return e
        })
        await updateCandidate(c.id, { route: updatedRoute, expenses: updatedExpenses })
      } else {
        // Новая поездка
        let expenseCategory
        if (isBus) expenseCategory = 'Автобус'
        else if (isReturn) expenseCategory = 'Обратный авиабилет'
        else expenseCategory = 'Авиабилет'

        const expenseEntry = price ? {
          category: expenseCategory,
          amount: parseFloat(price),
          date: purchaseDate || firstSeg.departure_date,
          comment: (isBus ? 'Автобус' : isReturn ? 'Обратный билет' : 'Билет') + ': ' + firstSeg.from + ' → ' + segments[segments.length - 1].to + (airline ? ' (' + airline + ')' : '') + (ticketNumber ? ' №' + ticketNumber : '') + (tripComment ? ' | ' + tripComment : ''),
          ticket_id: ticketId,
        } : null
        const agentFields = fromAgent.enabled ? { from_agent: true, agent_source_id: fromAgent.agent_source_id, agent_source_name: fromAgent.agent_source_name, agent_amount: parseFloat(price) || 0 } : {}
        const expenseWithAgent = expenseEntry ? { ...expenseEntry, ...agentFields } : null
        const updatedExpenses = expenseWithAgent ? [...(freshCandidate.expenses || []), expenseWithAgent] : [...(freshCandidate.expenses || [])]
        await updateCandidate(c.id, { route: sortRouteByDate([...(freshCandidate.route || []), ...newRoutePoints]), expenses: updatedExpenses })
      }

      setSegments([{ from: '', from_tz: 'Africa/Harare', to: '', to_tz: 'Africa/Harare', departure_date: '', departure_time: '', arrival_date: '', arrival_time: '' }])
      setTicketNumber(''); setPrice(''); setAirline(''); setAggregator(''); setPaymentMethod('')
      setTripFile(null); setTripComment(''); setOpenId(null); setIsReturn(false); setTransportType('автобус'); setPurchaseDate(new Date().toISOString().split('T')[0]); setEditRouteIdx(null)
      setFromAgent({ enabled: false, agent_source_id: '', agent_source_name: '' })
      onSaved()
    } catch (e) { alert('Ошибка: ' + e.message) }
    setSaving(false)
  }

  const filtered = candidates.filter(c => {
    if (!search) return true
    const q = search.toLowerCase()
    return c.name?.toLowerCase().includes(q) || c.passport?.toLowerCase().includes(q)
  }).sort((a, b) => {
    const aLen = (Array.isArray(a.route) ? a.route : []).filter(p => p.from && p.to).length
    const bLen = (Array.isArray(b.route) ? b.route : []).filter(p => p.from && p.to).length
    return bLen - aLen
  })

  const inputStyle = { width: '100%', fontSize: 13, padding: '6px 10px', borderRadius: 8, border: '1px solid #e0e0dc', boxSizing: 'border-box' }

  return (
    <div>
      <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Поиск по имени или паспорту..." style={{ ...inputStyle, marginBottom: 12 }} />
      {filtered.map(c => {
        const route = (Array.isArray(c.route) ? c.route : []).filter(p => p.from && p.to)
        return (
        <div key={c.id} style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 10, marginBottom: 8, overflow: 'hidden' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 14px' }}>
            <div>
              <span style={{ fontWeight: 500, fontSize: 13 }}>{c.name}</span>
              <span style={{ color: '#aaa', fontSize: 11, marginLeft: 8 }}>{locations.find(l => l.id === c.location_id)?.name || '—'}</span>
{route.length > 0 && <span onClick={() => setOpenTrips(prev => ({ ...prev, [c.id]: !prev[c.id] }))} style={{ fontSize: 11, color: '#378ADD', marginLeft: 8, cursor: 'pointer' }}>✈ {route.length} сегм. {openTrips[c.id] ? '▲' : '▼'}</span>}
            </div>
            <button onClick={() => closeTripForm(c.id)} style={{ fontSize: 12, padding: '4px 10px', borderRadius: 6, border: 'none', background: openId === c.id ? '#e8e8e5' : '#1a1a1a', color: openId === c.id ? '#444' : 'white', cursor: 'pointer' }}>
              {openId === c.id ? 'Закрыть' : '+ Поездка'}
            </button>
          </div>
{route.length > 0 && openTrips[c.id] && (
            <div style={{ padding: '0 14px 10px', borderTop: '1px solid #f5f5f3' }}>
              {(() => {
                const allRoute = Array.isArray(c.route) ? c.route : []
                const groups = []
                const sortedRoute = [...route].sort((a, b) => {
                  const da = a.from_date || a.departure_date || ''
                  const db = b.from_date || b.departure_date || ''
                  return da.localeCompare(db)
                })
                sortedRoute.forEach(p => {
                  if (p.ticket_id) {
                    const existing = groups.find(g => g.ticket_id === p.ticket_id)
                    if (existing) { existing.points.push(p); return }
                  }
                  groups.push({ ticket_id: p.ticket_id || null, points: [p], is_return: p.is_return, transport_type: p.transport_type })
                })
                return groups.map((g, gi) => {
                  const firstPoint = g.points[0]
                  const lastPoint = g.points[g.points.length - 1]
                  const isMulti = g.points.length > 1
                  return (
                    <div key={gi} style={{ borderBottom: '0.5px solid #f5f5f3', padding: '4px 0' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, alignItems: 'center' }}>
                        <div style={{ color: '#444', display: 'flex', alignItems: 'center', gap: 6 }}>
                          {firstPoint.transport_type === 'автобус' ? '🚌' : '✈'}
                          {isMulti ? `${firstPoint.from} → ${lastPoint.to}` : `${firstPoint.from} → ${firstPoint.to}`}
                          {g.is_return && <span style={{ fontSize: 9, fontWeight: 600, padding: '1px 5px', borderRadius: 8, background: '#E6F1FB', color: '#0C447C' }}>обратный</span>}
                          {isMulti && <span style={{ fontSize: 9, color: '#888' }}>({g.points.length} пересадки)</span>}
                        </div>
                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                          <span style={{ color: '#888', fontSize: 11 }}>{firstPoint.from_date ? String(firstPoint.from_date).slice(0,10).split('-').reverse().join('.') : ''}</span>
                          <button onClick={() => {
                            const idx = allRoute.indexOf(firstPoint)
                            handleStartEdit(c, idx === -1 ? allRoute.findIndex(r => r.from === firstPoint.from && r.to === firstPoint.to && r.from_date === firstPoint.from_date) : idx)
                          }} style={{ fontSize: 10, padding: '2px 6px', borderRadius: 4, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#555' }}>✏</button>
                        </div>
                      </div>
                      {firstPoint.files && firstPoint.files.length > 0 && (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 3, paddingLeft: 2 }}>
                          {firstPoint.files.map((f, fi) => {
                            const pointIdx = allRoute.indexOf(firstPoint) === -1 ? allRoute.findIndex(r => r.from === firstPoint.from && r.to === firstPoint.to && r.from_date === firstPoint.from_date) : allRoute.indexOf(firstPoint)
                            return (
                              <span key={fi} style={{ display: 'flex', alignItems: 'center', gap: 2, background: '#f0f4fa', borderRadius: 4, padding: '1px 5px' }}>
                                <a href={f.url} target="_blank" rel="noreferrer" style={{ fontSize: 11, color: '#185FA5', textDecoration: 'none' }}>📎 {f.name || 'файл'}</a>
                                <button onClick={() => handleDeleteRouteFile(c, pointIdx, fi)} title="Удалить файл" disabled={deletingFile === `${c.id}_${pointIdx}_${fi}`} style={{ background: 'none', border: 'none', cursor: deletingFile === `${c.id}_${pointIdx}_${fi}` ? 'wait' : 'pointer', color: '#e57373', fontSize: 13, padding: '0 2px', lineHeight: 1, opacity: deletingFile === `${c.id}_${pointIdx}_${fi}` ? 0.4 : 1 }}>{deletingFile === `${c.id}_${pointIdx}_${fi}` ? '…' : '✕'}</button>
                              </span>
                            )
                          })}
                        </div>
                      )}
                      {isMulti && (
                        <div style={{ paddingLeft: 18, marginTop: 2 }}>
                          {g.points.map((p, pi) => (
                            <div key={pi} style={{ fontSize: 11, color: '#888', padding: '1px 0' }}>
                              {p.from} → {p.to}{p.from_date ? ` · ${String(p.from_date).slice(0,10).split('-').reverse().join('.')}` : ''}
                            </div>
                          ))}
                        </div>
                      )}
                      {firstPoint.comment && (
                        <div style={{ fontSize: 11, color: '#888', fontStyle: 'italic', paddingLeft: 2, marginTop: 2 }}>
                          💬 {firstPoint.comment}
                        </div>
                      )}
                    </div>
                  )
                })
              })()}
            </div>
          )}
          {openId === c.id && (
            <div style={{ padding: '0 14px 14px', borderTop: '1px solid #f0f0ec' }}>
              {editRouteIdx && editRouteIdx.candidateId === c.id && (
                <div style={{ marginTop: 10, fontSize: 12, fontWeight: 600, color: '#378ADD' }}>✏ Редактирование поездки</div>
              )}
              {/* Тип транспорта */}
              <div style={{ display: 'flex', gap: 6, marginTop: 12, marginBottom: 10 }}>
                {['автобус', 'авиа'].map(type => (
                  <button key={type} onClick={() => { setTransportType(type); if (type === 'автобус') { setAddToRegistry(false); setIsReturn(false) } else { setAddToRegistry(true) } }}
                    style={{ flex: 1, padding: '7px 0', borderRadius: 8, border: '2px solid', fontSize: 13, fontWeight: 600, cursor: 'pointer',
                      borderColor: transportType === type ? '#1a1a1a' : '#e0e0dc',
                      background: transportType === type ? '#1a1a1a' : 'white',
                      color: transportType === type ? 'white' : '#888' }}>
                    {type === 'авиа' ? '✈️ Авиабилет' : '🚌 Автобус'}
                  </button>
                ))}
              </div>
              {segments.map((seg, idx) => (
                <div key={idx} style={{ background: '#fafaf8', borderRadius: 8, padding: 10, marginTop: 10, marginBottom: 6 }}>
                  <div style={{ fontSize: 11, fontWeight: 600, color: '#888', marginBottom: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>{idx === 0 ? 'Маршрут' : 'Стыковка ' + idx}</span>
                    {idx > 0 && <button onClick={() => removeSegment(idx)} style={{ fontSize: 12, color: '#bbb', background: 'none', border: 'none', cursor: 'pointer', padding: '0 2px', lineHeight: 1 }}>✕</button>}
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
                    <div><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Откуда</div><input list="cities-list" value={seg.from} onChange={e => setSeg(idx, 'from', e.target.value)} style={inputStyle} /></div>
                    <div><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Куда</div><input list="cities-list" value={seg.to} onChange={e => setSeg(idx, 'to', e.target.value)} style={inputStyle} /></div>
                    <div><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>{transportType === 'автобус' ? 'Дата отъезда' : 'Дата вылета'}</div><input type="date" value={seg.departure_date} onChange={e => setSeg(idx, 'departure_date', e.target.value)} style={inputStyle} /></div>
                    <div><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>{transportType === 'автобус' ? 'Время отъезда' : 'Время вылета'}</div><input type="time" value={seg.departure_time} onChange={e => setSeg(idx, 'departure_time', e.target.value)} style={inputStyle} /></div>
                    <div><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>{transportType === 'автобус' ? 'Дата приезда' : 'Дата прилёта'}</div><input type="date" value={seg.arrival_date} onChange={e => setSeg(idx, 'arrival_date', e.target.value)} style={inputStyle} /></div>
                    <div><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>{transportType === 'автобус' ? 'Время приезда' : 'Время прилёта'}</div><input type="time" value={seg.arrival_time} onChange={e => setSeg(idx, 'arrival_time', e.target.value)} style={inputStyle} /></div>
                    <div><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Часовой пояс откуда</div><select value={seg.from_tz} onChange={e => setSeg(idx, 'from_tz', e.target.value)} style={inputStyle}>{TIMEZONES.map(tz => <option key={tz.value} value={tz.value}>{tz.label}</option>)}</select></div>
                    <div><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Часовой пояс куда</div><select value={seg.to_tz} onChange={e => setSeg(idx, 'to_tz', e.target.value)} style={inputStyle}>{TIMEZONES.map(tz => <option key={tz.value} value={tz.value}>{tz.label}</option>)}</select></div>
                  </div>
                </div>
              ))}
              <button onClick={addSegment} style={{ fontSize: 12, padding: '4px 12px', borderRadius: 6, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', marginTop: 4, marginBottom: 8 }}>+ Стыковка</button>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
                <div><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Номер билета</div><input value={ticketNumber} onChange={e => setTicketNumber(e.target.value)} style={inputStyle} /></div>
                <div><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Стоимость (₽)</div><input type="text" inputMode="numeric" value={price} onChange={e => setPrice(e.target.value.replace(/[^0-9.]/g, ''))} style={inputStyle} /></div>
                <div style={{ gridColumn: '1 / -1' }}><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Дата покупки</div><input type="date" value={purchaseDate} onChange={e => setPurchaseDate(e.target.value)} style={inputStyle} /></div>
                {transportType === 'авиа' && <>
                  <div><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Авиакомпания</div><input value={airline} onChange={e => setAirline(e.target.value)} placeholder="Ethiopian Airlines" style={inputStyle} /></div>
                  <div><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Агрегатор</div><input value={aggregator} onChange={e => setAggregator(e.target.value)} placeholder="Aviasales, Kiwi..." style={inputStyle} /></div>
                </>}
                <div style={{ gridColumn: '1 / -1' }}>
                  <div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Способ оплаты</div>
                  <input value={paymentMethod} onChange={e => setPaymentMethod(e.target.value)} placeholder="Карта, наличные, перевод..." style={inputStyle} />
                </div>
                <div style={{ gridColumn: '1 / -1' }}>
                  <div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Комментарий</div>
                  <textarea value={tripComment} onChange={e => setTripComment(e.target.value)} placeholder="Заметки к поездке..." rows={2} style={{ ...inputStyle, resize: 'vertical', fontFamily: 'inherit' }} />
                </div>
              </div>
              <div style={{ marginBottom: 10 }}>
                <label style={{ display: 'inline-block', fontSize: 12, padding: '6px 12px', border: '1px dashed #d0d0cc', borderRadius: 7, cursor: 'pointer', color: '#888' }}>
                  📎 {tripFile ? tripFile.name : 'Прикрепить файл билета'}
                  <input type="file" accept="image/*,.pdf" onChange={e => setTripFile(e.target.files[0])} style={{ display: 'none' }} />
                </label>
              </div>
              {transportType === 'авиа' && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 12 }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', userSelect: 'none' }}>
                    <input type="checkbox" checked={isReturn} onChange={e => { setIsReturn(e.target.checked); if (e.target.checked) setAddToRegistry(true) }} style={{ width: 15, height: 15, cursor: 'pointer' }} />
                    <span style={{ fontSize: 13, color: '#1a1a1a' }}>Обратный билет</span>
                    {isReturn && <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 10, background: '#dbeafe', color: '#1d4ed8' }}>обратный</span>}
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: isReturn ? 'default' : 'pointer', userSelect: 'none', opacity: isReturn ? 0.5 : 1 }}>
                    <input type="checkbox" checked={addToRegistry || isReturn} disabled={isReturn} onChange={e => setAddToRegistry(e.target.checked)} style={{ width: 15, height: 15, cursor: isReturn ? 'default' : 'pointer' }} />
                    <span style={{ fontSize: 13, color: '#1a1a1a' }}>Добавить в реестр билетов</span>
                  </label>
                </div>
              )}
              {transportType === 'автобус' && (
                <div style={{ marginBottom: 12, padding: '8px 12px', background: '#f5f5f3', borderRadius: 8, fontSize: 12, color: '#888' }}>
                  🚌 Автобусный билет — попадает в календарь, но <strong>не добавляется в реестр билетов</strong>. Категория расхода: <strong>Автобус</strong>
                </div>
              )}
              <button onClick={() => handleSave(c)} disabled={saving} style={{ fontSize: 13, padding: '8px 20px', borderRadius: 8, border: 'none', background: '#1a1a1a', color: 'white', cursor: 'pointer', fontWeight: 600 }}>
                {saving ? 'Сохранение...' : editRouteIdx && editRouteIdx.candidateId === c.id ? 'Сохранить изменения' : 'Добавить поездку'}
              </button>
              {canSeeAgents && <div style={{ marginTop: 10 }}>
                <label style={{ display: 'inline-flex', alignItems: 'center', gap: 7, fontSize: 13, cursor: 'pointer', userSelect: 'none' }}>
                  <input type="checkbox" checked={!!fromAgent.enabled} onChange={e => setFromAgent({ enabled: e.target.checked, agent_source_id: '', agent_source_name: '' })} />
                  <span style={{ fontWeight: 500, color: fromAgent.enabled ? '#c07840' : '#555' }}>🤝 Расход от агента</span>
                </label>
                {fromAgent.enabled && (
                  <div style={{ marginTop: 8 }}>
                    <select value={fromAgent.agent_source_id} onChange={e => {
                      const ag = (agents || []).find(a => a.id === e.target.value)
                      setFromAgent(f => ({ ...f, agent_source_id: e.target.value, agent_source_name: ag?.name || '' }))
                    }} style={{ width: '100%', fontSize: 13, padding: '6px 10px', borderRadius: 8, border: '1px solid #f0c080', background: '#fffbf0', boxSizing: 'border-box' }}>
                      <option value="">— выбрать агента —</option>
                      {(agents || []).map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
                    </select>
                  </div>
                )}
              </div>}
</div>
          )}
          <datalist id="cities-list">
            {cities.map(city => <option key={city.id || city.name} value={city.name} />)}
          </datalist>
        </div>
        )
      })}
    </div>
  )
}
function ExpenseInlineSection({ candidates, locations, currentUserId, onRefresh, agents, canSeeAgents = true }) {
  const [openId, setOpenId] = useState(null)
  const [openExpenses, setOpenExpenses] = useState({})
  const [openCategoryItems, setOpenCategoryItems] = useState({})
  const [form, setForm] = useState({ category: '', amount: '', comment: '', date: '', from_agent: false, agent_source_id: '', agent_source_name: '' })
  const [expenseFile, setExpenseFile] = useState(null)
  const [saving, setSaving] = useState(false)
  const [search, setSearch] = useState('')
  const [editKey, setEditKey] = useState(null) // candidateId + '::' + expenseIndex
  const [sortBy, setSortBy] = useState('recent')

  const CATEGORIES = ['Авиабилет', 'Обратный авиабилет', 'Транспорт', 'Автобус', 'Отель/жильё', 'Еда', 'Медицина', 'Виза', 'Паспорт/документы', 'Переводчик', 'Карманные деньги', 'SIM-карта/связь', 'Банк', 'Багаж', 'Прочее']

  async function handleSave(c) {
    if (!form.amount) { alert('Введите сумму'); return }
    if (!form.date) { alert('Укажите дату расхода'); return }
    setSaving(true)
    try {
      let fileData = null
      if (expenseFile) fileData = await uploadRouteFile(expenseFile, 'expense_' + c.id + '_' + Date.now(), 'expense')
      const fresh = await fetchCandidateById(c.id)
      const freshExpenses = Array.isArray(fresh.expenses) ? [...fresh.expenses] : []
      const agentFields = form.from_agent ? { from_agent: true, agent_source_id: form.agent_source_id, agent_source_name: form.agent_source_name, agent_amount: parseFloat(form.amount) || 0 } : {}
      if (editKey) {
        const idx = parseInt(editKey.split('::')[1])
        freshExpenses[idx] = { ...freshExpenses[idx], category: form.category || 'Прочее', amount: parseFloat(form.amount), comment: form.comment, date: form.date, ...(fileData ? { file: fileData } : {}), ...agentFields }
      } else {
        freshExpenses.push({ category: form.category || 'Прочее', amount: parseFloat(form.amount), comment: form.comment, date: form.date, operator_id: currentUserId, location_id: c.location_id, location_name: locations.find(l => l.id === c.location_id)?.name || '', ...(fileData ? { file: fileData } : {}), ...agentFields })
      }
      await updateCandidate(c.id, { expenses: freshExpenses })
      setForm({ category: '', amount: '', comment: '', date: '', from_agent: false, agent_source_id: '', agent_source_name: '' })
      setExpenseFile(null)
      setEditKey(null)
      setOpenId(null)
      setOpenExpenses(prev => ({ ...prev, [c.id]: true }))
      onRefresh()
    } catch (e) { alert('Ошибка: ' + e.message) }
    setSaving(false)
  }

  return (
    <div>
      <div style={{ fontSize: 13, color: '#888', marginBottom: 12 }}>Нажмите на кандидата чтобы увидеть расходы или добавить новый:</div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Поиск по имени или паспорту..." style={{ flex: 1, fontSize: 13, padding: '8px 12px', borderRadius: 8, border: '1px solid #e0e0dc', boxSizing: 'border-box' }} />
        <select value={sortBy} onChange={e => setSortBy(e.target.value)} style={{ fontSize: 13, padding: '8px 10px', borderRadius: 8, border: '1px solid #e0e0dc' }}>
          <option value="recent">По последнему расходу</option>
          <option value="amount">По сумме</option>
        </select>
      </div>
      {[...candidates].filter(c => !c.archived && c.status !== 'завершен' && !c.moscow_completed).filter(c => {
        if (!search) return true
        const q = search.toLowerCase()
        return c.name?.toLowerCase().includes(q) || c.passport?.toLowerCase().includes(q)
      }).sort((a, b) => {
        if (sortBy === 'amount') {
          const sumA = (a.expenses || []).reduce((s, e) => s + (parseFloat(e.amount) || 0), 0)
          const sumB = (b.expenses || []).reduce((s, e) => s + (parseFloat(e.amount) || 0), 0)
          return sumB - sumA
        }
        const lastA = (a.expenses || []).map(e => e.date || '').filter(Boolean).sort().pop() || ''
        const lastB = (b.expenses || []).map(e => e.date || '').filter(Boolean).sort().pop() || ''
        return lastB.localeCompare(lastA)
      }).map(c => {
        const expenses = c.expenses || []
        const total = expenses.reduce((sum, e) => sum + (parseFloat(e.amount) || 0), 0)
        const byCategory = expenses.reduce((acc, e, idx) => {
          const cat = e.category || 'Прочее'
          if (!acc[cat]) acc[cat] = { sum: 0, items: [] }
          acc[cat].sum += parseFloat(e.amount) || 0
          acc[cat].items.push({ ...e, _idx: idx })
          return acc
        }, {})
        const isExpOpen = openExpenses[c.id]

        return (
          <div key={c.id} style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 10, marginBottom: 8, overflow: 'hidden' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 14px' }}>
              <div style={{ flex: 1, cursor: expenses.length > 0 ? 'pointer' : 'default' }} onClick={() => expenses.length > 0 && setOpenExpenses(prev => ({ ...prev, [c.id]: !prev[c.id] }))}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontWeight: 500, fontSize: 13 }}>{c.name}</span>
                  <span style={{ color: '#aaa', fontSize: 11 }}>{locations.find(l => l.id === c.location_id)?.name || '—'}</span>
                  {total > 0 && <span style={{ fontSize: 12, fontWeight: 600, color: '#639922', marginLeft: 4 }}>{total.toLocaleString('ru-RU')} ₽</span>}
                  {expenses.length > 0 && <span style={{ fontSize: 11, color: '#aaa' }}>{isExpOpen ? '▲' : '▼'} {expenses.length} записей</span>}
                </div>
              </div>
              <button onClick={() => { setOpenId(openId === c.id ? null : c.id); setForm({ category: '', amount: '', comment: '', date: '', from_agent: false, agent_source_id: '', agent_source_name: '' }) }} style={{ fontSize: 12, padding: '4px 10px', borderRadius: 6, border: 'none', background: openId === c.id ? '#e8e8e5' : '#1a1a1a', color: openId === c.id ? '#444' : 'white', cursor: 'pointer', marginLeft: 8, flexShrink: 0 }}>
                {openId === c.id ? 'Закрыть' : '+ Расход'}
              </button>
            </div>

            {isExpOpen && expenses.length > 0 && (
              <div style={{ padding: '0 14px 10px', borderTop: '1px solid #f5f5f3' }}>
                {Object.entries(byCategory).map(([cat, { sum, items }]) => {
                  const catKey = c.id + '::' + cat
                  const isCatOpen = !!openCategoryItems[catKey]
                  return (
                    <div key={cat} style={{ borderBottom: '0.5px solid #f5f5f3' }}>
                      <div
                        onClick={() => setOpenCategoryItems(prev => ({ ...prev, [catKey]: !prev[catKey] }))}
                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 12, padding: '6px 0', cursor: 'pointer', userSelect: 'none' }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                          <span style={{ fontSize: 10, color: '#bbb', width: 10 }}>{isCatOpen ? '▼' : '▶'}</span>
                          <span style={{ color: '#666' }}>{cat}</span>
                          <span style={{ fontSize: 11, color: '#bbb' }}>({items.length})</span>
                        </div>
                        <span style={{ fontWeight: 500 }}>{sum.toLocaleString('ru-RU')} ₽</span>
                      </div>
                      {isCatOpen && (
                        <div style={{ paddingBottom: 6 }}>
                          {items.sort((a, b) => (b.date || '') > (a.date || '') ? 1 : -1).map((e, j) => (
                            <div key={j} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 8px', borderRadius: 6, background: '#fafaf8', marginBottom: 2, fontSize: 11 }}>
                              <span style={{ color: '#bbb', whiteSpace: 'nowrap', minWidth: 65 }}>
                                {e.date ? e.date.split('T')[0].split('-').reverse().join('.') : '—'}
                              </span>
                              {e.comment && <span style={{ color: '#aaa', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.comment}</span>}
                              {e.from_agent && canSeeAgents && <span style={{ fontSize: 10, color: '#c07840', background: '#fffbf0', border: '1px solid #f0c080', borderRadius: 4, padding: '1px 5px', whiteSpace: 'nowrap' }}>🤝 {e.agent_source_name || 'агент'}{e.agent_amount ? ` · ${Number(e.agent_amount).toLocaleString('ru-RU')} ₽` : ''}</span>}
                              {e.file?.url && <a href={e.file.url} target="_blank" rel="noreferrer" style={{ fontSize: 10, color: '#185FA5', textDecoration: 'none', whiteSpace: 'nowrap' }}>📎</a>}
                              <span style={{ fontWeight: 600, color: parseFloat(e.amount) < 0 ? '#27500A' : '#1a1a1a', whiteSpace: 'nowrap', marginLeft: 'auto' }}>{parseFloat(e.amount).toLocaleString('ru-RU')} ₽</span>
                              <button
                                onClick={() => {
                                  setOpenId(c.id)
                                  setEditKey(c.id + '::' + e._idx)
                                  setForm({ category: e.category || '', amount: String(e.amount || ''), comment: e.comment || '', date: e.date ? e.date.split('T')[0] : '' })
                                  setOpenExpenses(prev => ({ ...prev, [c.id]: true }))
                                }}
                                style={{ fontSize: 11, padding: '2px 6px', borderRadius: 4, border: '1px solid #e0e0dc', background: 'white', color: '#555', cursor: 'pointer', flexShrink: 0 }}
                              >✏</button>
                              <button
                                onClick={async () => {
                                  if (!window.confirm('Удалить этот расход?')) return
                                  const fresh = await fetchCandidateById(c.id)
                                  const expToDelete = (fresh.expenses || [])[e._idx]
                                  const updated = (fresh.expenses || []).filter((_, i) => i !== e._idx)
                                  await updateCandidate(c.id, { expenses: updated })
                                  // Если удаляем расход "Оформление в Москве" — обнуляем cost в пайплайне
                                  if (expToDelete?.category === 'Оформление в Москве' && expToDelete?.comment) {
                                    const commentToTask = {
                                      'Аренда жилья': 'housing_rent', 'Транспорт': 'transport',
                                      'Медицинские анализы': 'medical_tests', 'Покупка мобильного телефона': 'phone_purchase',
                                      'Нотариальный перевод паспорта': 'passport_translation', 'Страховка': 'insurance',
                                    }
                                    const taskId = commentToTask[expToDelete.comment]
                                    if (taskId) { try { await updateMoscowTask(c.id, taskId, { cost: 0 }) } catch {} }
                                  }
                                  onRefresh()
                                }}
                                style={{ fontSize: 11, padding: '2px 6px', borderRadius: 4, border: '1px solid #f0c0c0', background: '#fff5f5', color: '#E24B4A', cursor: 'pointer', flexShrink: 0 }}
                              >✕</button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )
                })}
              </div>
            )}

            {openId === c.id && (
              <div style={{ padding: '0 14px 14px', borderTop: '1px solid #f0f0ec' }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#888', margin: '10px 0 8px' }}>{editKey ? 'Редактировать расход' : 'Новый расход'}</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
                  <div>
                    <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Категория</div>
                    <select value={form.category} onChange={e => setForm(f => ({ ...f, category: e.target.value }))} style={{ width: '100%', fontSize: 13, padding: '7px 10px', borderRadius: 8, border: '1px solid #e0e0dc' }}>
                      <option value="">— выбрать —</option>
                      {CATEGORIES.map(cat => <option key={cat} value={cat}>{cat}</option>)}
                    </select>
                  </div>
                  <div>
                    <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Сумма (₽)</div>
                    <input type="text" inputMode="numeric" value={form.amount} onChange={e => setForm(f => ({ ...f, amount: e.target.value.replace(/[^0-9.]/g, '') }))} placeholder="0" style={{ width: '100%', fontSize: 13, padding: '7px 10px', borderRadius: 8, border: '1px solid #e0e0dc', boxSizing: 'border-box' }} />
                  </div>
                </div>
<div style={{ marginBottom: 8 }}>
                  <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Дата расхода</div>
                  <input type="date" value={form.date} onChange={e => setForm(f => ({ ...f, date: e.target.value }))} style={{ width: '100%', fontSize: 13, padding: '7px 10px', borderRadius: 8, border: '1px solid #e0e0dc', boxSizing: 'border-box' }} />
                </div>                
<div style={{ marginBottom: 10 }}>
                  <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Комментарий</div>
                  <textarea value={form.comment} onChange={e => setForm(f => ({ ...f, comment: e.target.value }))} onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) e.preventDefault() }} placeholder="Необязательно (Shift+Enter для новой строки)" rows={2} style={{ width: '100%', fontSize: 13, padding: '7px 10px', borderRadius: 8, border: '1px solid #e0e0dc', boxSizing: 'border-box', resize: 'vertical', fontFamily: 'inherit' }} />
                </div>
                <div style={{ marginBottom: 10 }}>
                  <label style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12, color: expenseFile ? '#639922' : '#555', background: expenseFile ? '#EAF3DE' : '#f5f5f3', border: '1px solid #e0e0dc', borderRadius: 8, padding: '6px 12px', cursor: 'pointer' }}>
                    📎 {expenseFile ? expenseFile.name : 'Прикрепить файл'}
                    <input type="file" accept="image/*,.pdf,.doc,.docx,.xls,.xlsx" onChange={e => setExpenseFile(e.target.files[0])} style={{ display: 'none' }} />
                  </label>
                  {expenseFile && <button onClick={() => setExpenseFile(null)} style={{ marginLeft: 8, fontSize: 11, color: '#E24B4A', background: 'none', border: 'none', cursor: 'pointer' }}>✕ убрать</button>}
                </div>
                {/* Расход от агента */}
                {canSeeAgents && <div style={{ marginBottom: 10 }}>
                  <label style={{ display: 'inline-flex', alignItems: 'center', gap: 7, fontSize: 13, cursor: 'pointer', userSelect: 'none' }}>
                    <input type="checkbox" checked={!!form.from_agent} onChange={e => setForm(f => ({ ...f, from_agent: e.target.checked, agent_source_id: '', agent_source_name: '' }))} />
                    <span style={{ fontWeight: 500, color: form.from_agent ? '#c07840' : '#555' }}>🤝 Расход от агента</span>
                  </label>
                  {form.from_agent && (
                    <div style={{ marginTop: 8 }}>
                      <select value={form.agent_source_id} onChange={e => {
                        const ag = (agents || []).find(a => a.id === e.target.value)
                        setForm(f => ({ ...f, agent_source_id: e.target.value, agent_source_name: ag?.name || '' }))
                      }} style={{ width: '100%', fontSize: 13, padding: '6px 10px', borderRadius: 8, border: '1px solid #f0c080', background: '#fffbf0', boxSizing: 'border-box' }}>
                        <option value="">— выбрать агента —</option>
                        {(agents || []).map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
                      </select>
                    </div>
                  )}
                </div>}
                <div style={{ display: 'flex', gap: 8 }}>
                  <button onClick={() => handleSave(c)} disabled={saving} style={{ fontSize: 13, padding: '8px 20px', borderRadius: 8, border: 'none', background: '#639922', color: 'white', cursor: 'pointer', fontWeight: 600 }}>
                    {saving ? 'Сохранение...' : editKey ? 'Сохранить изменения' : 'Сохранить расход'}
                  </button>
                  {editKey && <button onClick={() => { setEditKey(null); setForm({ category: '', amount: '', comment: '', date: '' }); setOpenId(null) }} style={{ fontSize: 13, padding: '8px 14px', borderRadius: 8, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#888' }}>Отмена</button>}
                </div>
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}

function VisaInlineSection({ candidates, locations, onRefresh }) {
  const [search, setSearch] = useState('')
  const [openId, setOpenId] = useState(null)
  const [openVisas, setOpenVisas] = useState({})
  const [form, setForm] = useState({ name: '', submission_date: '', application_number: '' })
  const [visaFile, setVisaFile] = useState(null)
  const [saving, setSaving] = useState(false)
  const [editIdx, setEditIdx] = useState(null)
  const [addingFileTo, setAddingFileTo] = useState(null) // {cId, vi}

  const inputStyle = { width: '100%', fontSize: 13, padding: '6px 10px', borderRadius: 8, border: '1px solid #e0e0dc', boxSizing: 'border-box' }

  function resetForm() { setForm({ name: '', submission_date: '', application_number: '' }); setVisaFile(null); setEditIdx(null) }

  async function handleQuickAddFile(c, vi, file) {
    if (!file) return
    setAddingFileTo({ cId: c.id, vi })
    try {
      const fileData = await uploadRouteFile(file, 'visa_' + c.id + '_' + Date.now(), 'visa')
      const fresh = await fetchCandidateById(c.id)
      const freshVisas = Array.isArray(fresh.visas) ? [...fresh.visas] : []
      freshVisas[vi] = { ...freshVisas[vi], files: [...(freshVisas[vi].files || []), fileData] }
      await updateCandidate(c.id, { visas: freshVisas })
      onRefresh()
    } catch (e) { alert('Ошибка: ' + e.message) }
    finally { setAddingFileTo(null) }
  }

  async function handleSave(c) {
    if (!form.name.trim()) { alert('Укажите название визы'); return }
    setSaving(true)
    try {
      let fileData = null
      if (visaFile) fileData = await uploadRouteFile(visaFile, 'visa_' + c.id + '_' + Date.now(), 'visa')
      const visas = Array.isArray(c.visas) ? [...c.visas] : []
      const fresh = await fetchCandidateById(c.id)
      const freshVisas = Array.isArray(fresh.visas) ? [...fresh.visas] : []
      const newVisa = { name: form.name, submission_date: form.submission_date || null, application_number: form.application_number || null, files: fileData ? [fileData] : [] }
      if (editIdx !== null) {
        freshVisas[editIdx] = { ...freshVisas[editIdx], ...newVisa, files: [...(freshVisas[editIdx].files || []), ...(fileData ? [fileData] : [])] }
      } else {
        freshVisas.push(newVisa)
      }
      await updateCandidate(c.id, { visas: freshVisas })
      resetForm(); setOpenId(null); onRefresh()
    } catch (e) { alert('Ошибка: ' + e.message) }
    setSaving(false)
  }

  async function handleDelete(c, idx) {
    if (!window.confirm('Удалить эту визу?')) return
    const fresh = await fetchCandidateById(c.id)
    const freshVisas = (fresh.visas || []).filter((_, i) => i !== idx)
    await updateCandidate(c.id, { visas: freshVisas })
    onRefresh()
  }

  async function handleDeleteRouteFile(c, pointIdx, fileIdx) {
    if (!window.confirm('Удалить этот файл?')) return
    const key = `${c.id}_${pointIdx}_${fileIdx}`
    setDeletingFile(key)
    try {
      const fresh = await fetchCandidateById(c.id)
      const freshRoute = [...(fresh.route || [])]
      freshRoute[pointIdx] = { ...freshRoute[pointIdx], files: (freshRoute[pointIdx].files || []).filter((_, i) => i !== fileIdx) }
      await updateCandidate(c.id, { route: freshRoute })
      onRefresh()
    } finally {
      setDeletingFile(null)
    }
  }

  async function handleDeleteFile(c, visaIdx, fileIdx) {
    if (!window.confirm('Удалить этот файл?')) return
    const fresh = await fetchCandidateById(c.id)
    const freshVisas = [...(fresh.visas || [])]
    freshVisas[visaIdx] = { ...freshVisas[visaIdx], files: (freshVisas[visaIdx].files || []).filter((_, i) => i !== fileIdx) }
    await updateCandidate(c.id, { visas: freshVisas })
    onRefresh()
  }

  const filtered = candidates.filter(c => {
    if (!search) return true
    const q = search.toLowerCase()
    return c.name?.toLowerCase().includes(q) || c.passport?.toLowerCase().includes(q)
  })

  return (
    <div>
      <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Поиск по имени или паспорту..." style={{ ...inputStyle, marginBottom: 12 }} />
      {filtered.map(c => {
        const visas = Array.isArray(c.visas) ? c.visas : []
        const isOpen = openVisas[c.id]
        return (
          <div key={c.id} style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 10, marginBottom: 8, overflow: 'hidden' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 14px' }}>
              <div>
                <span style={{ fontWeight: 500, fontSize: 13 }}>{c.name}</span>
                <span style={{ color: '#aaa', fontSize: 11, marginLeft: 8 }}>{locations.find(l => l.id === c.location_id)?.name || '—'}</span>
                {visas.length > 0 && <span style={{ fontSize: 11, color: '#378ADD', marginLeft: 8 }}>🛂 {visas.length}</span>}
              </div>
              <button onClick={() => { setOpenId(openId === c.id ? null : c.id); resetForm() }}
                style={{ fontSize: 12, padding: '4px 10px', borderRadius: 6, border: 'none', background: openId === c.id ? '#e8e8e5' : '#1a1a1a', color: openId === c.id ? '#444' : 'white', cursor: 'pointer' }}>
                {openId === c.id ? 'Закрыть' : '+ Виза'}
              </button>
            </div>

            {visas.length > 0 && (
              <div style={{ padding: '0 14px 10px', borderTop: '1px solid #f5f5f3' }}>
                {visas.map((visa, vi) => (
                  <div key={vi} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, padding: '8px 0', borderBottom: '0.5px solid #f5f5f3', fontSize: 12 }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 600 }}>🛂 {visa.name}</div>
                      {visa.submission_date && <div style={{ color: '#888', fontSize: 11 }}>Дата подачи: {visa.submission_date.split('-').reverse().join('.')}</div>}
                      {!visa.submission_date && <div style={{ color: '#f59e0b', fontSize: 11 }}>Дата подачи не указана</div>}
                      {visa.application_number && <div style={{ color: '#888', fontSize: 11 }}>№ заявки: {visa.application_number}</div>}
                      {(visa.files || []).map((f, fi) => (
                        <div key={fi} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                          <a href={f.url} target="_blank" rel="noreferrer" style={{ fontSize: 11, color: '#185FA5', textDecoration: 'none' }}>📎 {f.name}</a>
                          <button onClick={() => handleDeleteFile(c, vi, fi)} title="Удалить файл"
                            style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#e57373', fontSize: 13, padding: '0 2px', lineHeight: 1 }}>✕</button>
                        </div>
                      ))}
                    </div>
                    <div style={{ display: 'flex', gap: 4, flexShrink: 0, alignItems: 'flex-start' }}>
                      <label title="Добавить файл" style={{ fontSize: 11, padding: '3px 8px', borderRadius: 5, border: '1px solid #b8d4f0', background: '#f0f7ff', cursor: 'pointer', color: '#378ADD', whiteSpace: 'nowrap' }}>
                        {addingFileTo?.cId === c.id && addingFileTo?.vi === vi ? '...' : '+ Файл'}
                        <input type="file" accept="image/*,.pdf" style={{ display: 'none' }} onChange={e => { handleQuickAddFile(c, vi, e.target.files[0]); e.target.value = '' }} />
                      </label>
                      <button onClick={() => { setOpenId(c.id); setForm({ name: visa.name || '', submission_date: visa.submission_date || '', application_number: visa.application_number || '' }); setEditIdx(vi) }}
                        style={{ fontSize: 11, padding: '3px 8px', borderRadius: 5, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#555' }}>✏</button>
                      <button onClick={() => handleDelete(c, vi)}
                        style={{ fontSize: 11, padding: '3px 8px', borderRadius: 5, border: '1px solid #fca5a5', background: '#fff5f5', cursor: 'pointer', color: '#E24B4A' }}>✕</button>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {openId === c.id && (
              <div style={{ padding: '0 14px 14px', borderTop: '1px solid #f0f0ec' }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#888', margin: '10px 0 8px' }}>{editIdx !== null ? 'Редактировать визу' : 'Новая виза'}</div>
                <div style={{ marginBottom: 8 }}>
                  <div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Тип визы *</div>
                  <select value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} style={{ ...inputStyle, cursor: 'pointer' }}>
                    <option value="">— выбрать —</option>
                    <option value="РФ Спец">Спецвиза</option>
                    <option value="РФ">РФ виза</option>
                    <option value="E-visa">Е-виза</option>
                    <option value="Эфиопия">Эфиопия</option>
                  </select>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
                  <div>
                    <div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Дата подачи</div>
                    <input type="date" value={form.submission_date} onChange={e => setForm(f => ({ ...f, submission_date: e.target.value }))} style={inputStyle} />
                  </div>
                  <div>
                    <div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Номер заявки</div>
                    <input value={form.application_number} onChange={e => setForm(f => ({ ...f, application_number: e.target.value }))} placeholder="77985-63763-00492" style={inputStyle} />
                  </div>
                </div>
                <div style={{ marginBottom: 12 }}>
                  <label style={{ display: 'inline-block', fontSize: 12, padding: '6px 12px', border: '1px dashed #d0d0cc', borderRadius: 7, cursor: 'pointer', color: '#888' }}>
                    📎 {visaFile ? visaFile.name : 'Прикрепить файл визы'}
                    <input type="file" accept="image/*,.pdf" onChange={e => setVisaFile(e.target.files[0])} style={{ display: 'none' }} />
                  </label>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button onClick={() => handleSave(c)} disabled={saving}
                    style={{ fontSize: 13, padding: '8px 20px', borderRadius: 8, border: 'none', background: '#378ADD', color: 'white', cursor: 'pointer', fontWeight: 600 }}>
                    {saving ? 'Сохранение...' : editIdx !== null ? 'Сохранить изменения' : 'Добавить визу'}
                  </button>
                  {editIdx !== null && <button onClick={resetForm} style={{ fontSize: 13, padding: '8px 14px', borderRadius: 8, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#888' }}>Отмена</button>}
                </div>
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}

const AGENT_EXP_CATS = ['Аванс', 'Карманные деньги', 'Зарплата', 'Авиабилет', 'Отель/жильё', 'Еда', 'Командировка', 'Прочее']

function AgentExpenseSection({ agents, onRefresh }) {
  const [openId, setOpenId] = useState(null)
  const [openList, setOpenList] = useState({})
  const [form, setForm] = useState({ category: 'Карманные деньги', amount: '', comment: '', date: new Date().toISOString().split('T')[0] })
  const [file, setFile] = useState(null)
  const [saving, setSaving] = useState(false)
  const [editKey, setEditKey] = useState(null) // 'agentId::idx'
  const [editForm, setEditForm] = useState({})
  const inp = { width: '100%', fontSize: 13, padding: '7px 10px', borderRadius: 8, border: '1px solid #e0e0dc', boxSizing: 'border-box' }

  function fmtD(d) { return d ? String(d).slice(0,10).split('-').reverse().join('.') : '—' }

  async function handleAdd(agent) {
    if (!form.amount) { alert('Введите сумму'); return }
    setSaving(true)
    try {
      let fileData = null
      if (file) fileData = await uploadAgentFile(agent.id, 'expense', file)
      const newExp = { ...form, amount: parseFloat(form.amount), file: fileData, id: Date.now() }
      const freshA = await fetchAgentById(agent.id)
      await updateAgent(agent.id, { expenses: [...(freshA.expenses || []), newExp] })
      setForm({ category: 'Карманные деньги', amount: '', comment: '', date: new Date().toISOString().split('T')[0] })
      setFile(null)
      setOpenId(null)
      onRefresh()
    } catch (e) { alert('Ошибка: ' + e.message) }
    finally { setSaving(false) }
  }

  async function handleDelete(agent, idx) {
    if (!window.confirm('Удалить расход?')) return
    const freshA = await fetchAgentById(agent.id)
    const updated = (freshA.expenses || []).filter((_, i) => i !== idx)
    await updateAgent(agent.id, { expenses: updated })
    onRefresh()
  }

  async function handleSaveEdit(agent, idx) {
    if (!editForm.amount) { alert('Введите сумму'); return }
    setSaving(true)
    try {
      const freshA = await fetchAgentById(agent.id)
      const updated = (freshA.expenses || []).map((e, i) => i === idx ? { ...e, ...editForm, amount: parseFloat(editForm.amount) } : e)
      await updateAgent(agent.id, { expenses: updated })
      setEditKey(null)
      onRefresh()
    } catch (e) { alert('Ошибка: ' + e.message) }
    finally { setSaving(false) }
  }

  return (
    <div>
      {agents.map(agent => {
        const expenses = agent.expenses || []
        const total = expenses.reduce((s, e) => s + (parseFloat(e.amount) || 0), 0)
        return (
          <div key={agent.id} style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 10, marginBottom: 8, overflow: 'hidden' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 14px' }}>
              <div>
                <div style={{ fontWeight: 500, fontSize: 13 }}>{agent.name}</div>
                {expenses.length > 0 && (
                  <span onClick={() => setOpenList(p => ({ ...p, [agent.id]: !p[agent.id] }))} style={{ fontSize: 11, color: '#378ADD', cursor: 'pointer' }}>
                    💰 {expenses.length} расх. · {total.toLocaleString('ru-RU')} ₽ {openList[agent.id] ? '▲' : '▼'}
                  </span>
                )}
              </div>
              <button onClick={() => setOpenId(openId === agent.id ? null : agent.id)} style={{ fontSize: 12, padding: '4px 10px', borderRadius: 6, border: 'none', background: openId === agent.id ? '#e8e8e5' : '#1a1a1a', color: openId === agent.id ? '#444' : 'white', cursor: 'pointer' }}>
                {openId === agent.id ? 'Закрыть' : '+ Расход'}
              </button>
            </div>
            {expenses.length > 0 && openList[agent.id] && (
              <div style={{ padding: '0 14px 10px', borderTop: '1px solid #f5f5f3' }}>
                {expenses.map((e, i) => {
                  const eKey = agent.id + '::' + i
                  const isEditing = editKey === eKey
                  return (
                    <div key={i} style={{ fontSize: 12, padding: '5px 0', borderBottom: '0.5px solid #f5f5f3' }}>
                      {isEditing ? (
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, marginBottom: 6 }}>
                          <div>
                            <div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Категория</div>
                            <select value={editForm.category} onChange={ev => setEditForm(f => ({ ...f, category: ev.target.value }))} style={inp}>
                              {AGENT_EXP_CATS.map(c => <option key={c} value={c}>{c}</option>)}
                            </select>
                          </div>
                          <div>
                            <div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Сумма (₽)</div>
                            <input inputMode="numeric" value={editForm.amount} onChange={ev => setEditForm(f => ({ ...f, amount: ev.target.value.replace(/[^0-9.]/g, '') }))} style={inp} />
                          </div>
                          <div>
                            <div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Дата</div>
                            <input type="date" value={editForm.date || ''} onChange={ev => setEditForm(f => ({ ...f, date: ev.target.value }))} style={inp} />
                          </div>
                          <div>
                            <div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Комментарий</div>
                            <input value={editForm.comment || ''} onChange={ev => setEditForm(f => ({ ...f, comment: ev.target.value }))} style={inp} />
                          </div>
                          <div style={{ gridColumn: '1/-1', display: 'flex', gap: 6 }}>
                            <button onClick={() => handleSaveEdit(agent, i)} disabled={saving} style={{ flex: 1, padding: '6px', borderRadius: 7, background: '#1a1a1a', color: 'white', border: 'none', cursor: 'pointer', fontSize: 12 }}>{saving ? '...' : 'Сохранить'}</button>
                            <button onClick={() => setEditKey(null)} style={{ padding: '6px 12px', borderRadius: 7, background: '#f0f0ec', border: 'none', cursor: 'pointer', fontSize: 12 }}>Отмена</button>
                          </div>
                        </div>
                      ) : (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                          <div style={{ flex: 1 }}>
                            <div style={{ color: '#444', fontWeight: 500 }}>{e.category}</div>
                            <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginTop: 2, flexWrap: 'wrap' }}>
                              <span style={{ color: '#378ADD', fontWeight: 600 }}>{parseFloat(e.amount).toLocaleString('ru-RU')} ₽</span>
                              {e.date && <span style={{ color: '#aaa', fontSize: 11 }}>{fmtD(e.date)}</span>}
                              {e.comment && <span style={{ color: '#888', fontSize: 11 }}>{e.comment}</span>}
                              {e.file && <a href={e.file.url} target="_blank" rel="noreferrer" style={{ fontSize: 11, color: '#185FA5', textDecoration: 'none' }}>📎 {e.file.name}</a>}
                            </div>
                          </div>
                          <div style={{ display: 'flex', gap: 2, flexShrink: 0 }}>
                            <button onClick={() => { setEditKey(eKey); setEditForm({ category: e.category, amount: String(e.amount), date: e.date || '', comment: e.comment || '' }) }} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#aaa', fontSize: 13, lineHeight: 1, padding: '0 3px' }} title="Редактировать">✎</button>
                            <button onClick={() => handleDelete(agent, i)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ccc', fontSize: 14, lineHeight: 1, padding: '0 2px' }} title="Удалить">✕</button>
                          </div>
                        </div>
                      )}
                    </div>
                  )
                })}
              </div>
            )}
            {openId === agent.id && (
              <div style={{ padding: '0 14px 14px', borderTop: '1px solid #f0f0ec' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 12, marginBottom: 8 }}>
                  <div><div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Категория</div>
                    <select value={form.category} onChange={e => setForm(f => ({ ...f, category: e.target.value }))} style={inp}>
                      {AGENT_EXP_CATS.map(c => <option key={c} value={c}>{c}</option>)}
                    </select></div>
                  <div><div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Сумма (₽)</div>
                    <input inputMode="numeric" value={form.amount} onChange={e => setForm(f => ({ ...f, amount: e.target.value.replace(/[^0-9.]/g, '') }))} placeholder="0" style={inp} /></div>
                  <div><div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Дата</div>
                    <input type="date" value={form.date} onChange={e => setForm(f => ({ ...f, date: e.target.value }))} style={inp} /></div>
                  <div><div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Файл</div>
                    <input type="file" onChange={e => setFile(e.target.files[0])} style={{ fontSize: 12, marginTop: 4 }} /></div>
                  <div style={{ gridColumn: '1/-1' }}><div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Комментарий</div>
                    <textarea value={form.comment} onChange={e => setForm(f => ({ ...f, comment: e.target.value }))} onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) e.preventDefault() }} placeholder="... (Shift+Enter для новой строки)" rows={2} style={{ ...inp, resize: 'vertical', fontFamily: 'inherit' }} /></div>
                </div>
                <button onClick={() => handleAdd(agent)} disabled={saving} style={{ width: '100%', padding: '8px', borderRadius: 8, background: '#1a1a1a', color: 'white', border: 'none', cursor: 'pointer', fontSize: 13 }}>
                  {saving ? 'Сохранение...' : 'Добавить расход'}
                </button>
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}

const TRIP_TIMEZONES = [
  { label: 'Гватемала (UTC-6)', value: 'America/Guatemala' },
  { label: 'Богота / Лима (UTC-5)', value: 'America/Bogota' },
  { label: 'Каракас (UTC-4)', value: 'America/Caracas' },
  { label: 'Буэнос-Айрес (UTC-3)', value: 'America/Argentina/Buenos_Aires' },
  { label: 'Бразилиа (UTC-3)', value: 'America/Sao_Paulo' },
  { label: 'Кабо-Верде (UTC-1)', value: 'Atlantic/Cape_Verde' },
  { label: 'Лондон (UTC+0/+1)', value: 'Europe/London' },
  { label: 'Лагос / Луанда (UTC+1)', value: 'Africa/Lagos' },
  { label: 'Берлин / Париж (UTC+1/+2)', value: 'Europe/Berlin' },
  { label: 'Каир (UTC+2)', value: 'Africa/Cairo' },
  { label: 'Харare / Йоханнесбург (UTC+2)', value: 'Africa/Harare' },
  { label: 'Найроби / Аддис-Абеба (UTC+3)', value: 'Africa/Nairobi' },
  { label: 'Москва (UTC+3)', value: 'Europe/Moscow' },
  { label: 'Стамбул (UTC+3)', value: 'Europe/Istanbul' },
  { label: 'Дубай / Маскат (UTC+4)', value: 'Asia/Dubai' },
  { label: 'Карачи (UTC+5)', value: 'Asia/Karachi' },
  { label: 'Дели (UTC+5:30)', value: 'Asia/Kolkata' },
  { label: 'Дакка (UTC+6)', value: 'Asia/Dhaka' },
  { label: 'Бангкок / Джакарта (UTC+7)', value: 'Asia/Bangkok' },
  { label: 'Манила / Пекин (UTC+8)', value: 'Asia/Manila' },
  { label: 'Токио / Сеул (UTC+9)', value: 'Asia/Tokyo' },
  { label: 'Порт-Морсби (UTC+10)', value: 'Pacific/Port_Moresby' },
  { label: 'Сидней (UTC+10/+11)', value: 'Australia/Sydney' },
]
const EMPTY_SEG = () => ({ from: '', from_tz: 'Africa/Harare', to: '', to_tz: 'Africa/Harare', departure_date: '', departure_time: '', arrival_date: '', arrival_time: '' })

function AgentRouteSection({ agents, onRefresh }) {
  const [openId, setOpenId] = useState(null)
  const [openTrips, setOpenTrips] = useState({})
  const [segments, setSegments] = useState([EMPTY_SEG()])
  const [ticketNumber, setTicketNumber] = useState('')
  const [price, setPrice] = useState('')
  const [tripFile, setTripFile] = useState(null)
  const [deductAdvance, setDeductAdvance] = useState(false)
  const [saving, setSaving] = useState(false)
  const [transportType, setTransportType] = useState('автобус') // 'авиа' | 'автобус'
  const [paymentMethod, setPaymentMethod] = useState('')
  const [purchaseDate, setPurchaseDate] = useState(new Date().toISOString().split('T')[0])
  const [editRouteIdx, setEditRouteIdx] = useState(null)
  const [cities, setCities] = useState([])
  useEffect(() => { fetchCities().then(setCities).catch(() => {}) }, [])
  const inp = { width: '100%', fontSize: 13, padding: '6px 10px', borderRadius: 8, border: '1px solid #e0e0dc', boxSizing: 'border-box' }

  function setSeg(idx, field, value) {
    setSegments(segs => segs.map((s, i) => i === idx ? { ...s, [field]: value } : s))
  }

  function addSegment() {
    setSegments(segs => {
      const last = segs[segs.length - 1]
      return [...segs, { from: last.to, from_tz: last.to_tz, to: '', to_tz: last.to_tz, departure_date: '', departure_time: '', arrival_date: '', arrival_time: '' }]
    })
  }
  function removeSegment(idx) { setSegments(segs => segs.filter((_, i) => i !== idx)) }

  function resetForm() {
    setSegments([EMPTY_SEG()]); setTicketNumber(''); setPrice(''); setTripFile(null); setDeductAdvance(false)
    setTransportType('автобус'); setPaymentMethod(''); setPurchaseDate(new Date().toISOString().split('T')[0]); setEditRouteIdx(null)
  }

  function handleStartEdit(agent, idx) {
    const p = (Array.isArray(agent.route) ? agent.route : [])[idx]
    if (!p) return
    setOpenId(agent.id)
    setEditRouteIdx(idx)
    setTransportType(p.transport_type || 'автобус')
    setSegments([{
      from: p.from || '', from_tz: p.from_tz || 'Africa/Harare',
      to: p.to || '', to_tz: p.to_tz || 'Africa/Harare',
      departure_date: p.from_date ? String(p.from_date).slice(0, 10) : '',
      departure_time: p.from_time || '',
      arrival_date: p.to_date ? String(p.to_date).slice(0, 10) : '',
      arrival_time: p.to_time || '',
    }])
    setTicketNumber(p.ticket_number || '')
    setPrice(p.price ? String(p.price) : '')
    setPaymentMethod(p.payment_method || '')
    setPurchaseDate(p.purchase_date ? String(p.purchase_date).slice(0, 10) : new Date().toISOString().split('T')[0])
    setTripFile(null)
    setDeductAdvance(false)
    setOpenTrips(prev => ({ ...prev, [agent.id]: false }))
  }

  async function handleDeleteRoute(agent, idx) {
    if (!window.confirm('Удалить эту поездку?')) return
    const freshA = await fetchAgentById(agent.id)
    const updatedRoute = (freshA.route || []).filter((_, i) => i !== idx)
    await updateAgent(agent.id, { route: updatedRoute })
    onRefresh()
  }

  async function handleAdd(agent) {
    const first = segments[0]
    if (!first.from || !first.to || !first.departure_date) { alert('Заполните первый сегмент: откуда, куда, дату'); return }
    setSaving(true)
    try {
      let fileData = null
      if (tripFile) fileData = await uploadAgentFile(agent.id, 'route', tripFile)
      const isBus = transportType === 'автобус'
      const label = isBus ? 'Автобус' : 'Авиабилет'
      const freshA = await fetchAgentById(agent.id)

      if (editRouteIdx !== null) {
        // Редактирование существующей поездки
        const updatedRoute = [...(freshA.route || [])]
        const oldPoint = updatedRoute[editRouteIdx] || {}
        const last = segments[segments.length - 1]
        updatedRoute[editRouteIdx] = {
          ...oldPoint,
          from: first.from, from_tz: first.from_tz,
          from_date: first.departure_date, from_time: first.departure_time,
          to: last.to, to_tz: last.to_tz,
          to_date: last.arrival_date || last.departure_date, to_time: last.arrival_time,
          ticket_number: ticketNumber, price: price ? parseFloat(price) : 0,
          transport_type: transportType,
          payment_method: paymentMethod || null,
          purchase_date: purchaseDate || null,
          note: label,
          files: fileData ? [...(oldPoint.files || []), fileData] : (oldPoint.files || []),
        }
        await updateAgent(agent.id, { route: updatedRoute })
      } else {
        // Новая поездка
        const tripId = Date.now()
        const newPoints = segments.filter(s => s.from && s.to).map((s, i) => ({
          from: s.from, from_tz: s.from_tz, from_date: s.departure_date, from_time: s.departure_time,
          to: s.to, to_tz: s.to_tz, to_date: s.arrival_date || s.departure_date, to_time: s.arrival_time,
          ticket_number: ticketNumber, price: price ? parseFloat(price) : 0,
          note: label + (segments.length > 1 ? ' (сегмент ' + (i + 1) + ' из ' + segments.length + ')' : ''),
          transport_type: transportType,
          payment_method: paymentMethod || null,
          purchase_date: purchaseDate || null,
          files: fileData ? [fileData] : [],
          _tripId: tripId,
        }))
        const updates = { route: [...(freshA.route || []), ...newPoints] }
        if (price && parseFloat(price) > 0) {
          const last = segments[segments.length - 1]
          const expComment = first.from + ' → ' + last.to + (ticketNumber ? ' №' + ticketNumber : '') + (paymentMethod ? ' | ' + paymentMethod : '')
          const newExp = {
            category: deductAdvance ? 'Вычет из аванса' : (isBus ? 'Автобус' : 'Авиабилет'), amount: parseFloat(price),
            date: purchaseDate || first.departure_date || new Date().toISOString().split('T')[0],
            comment: expComment, file: fileData, id: tripId, _tripId: tripId,
          }
          updates.expenses = [...(freshA.expenses || []), newExp]
        }
        await updateAgent(agent.id, updates)
      }
      resetForm(); setOpenId(null); onRefresh()
    } catch (e) { alert('Ошибка: ' + e.message) }
    setSaving(false)
  }

  return (
    <div>
      {agents.map(agent => {
        const route = Array.isArray(agent.route) ? agent.route : []
        return (
          <div key={agent.id} style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 10, marginBottom: 8, overflow: 'hidden' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 14px' }}>
              <div>
                <div style={{ fontWeight: 500, fontSize: 13 }}>{agent.name}</div>
                {route.length > 0 && (
                  <span onClick={() => setOpenTrips(p => ({ ...p, [agent.id]: !p[agent.id] }))} style={{ fontSize: 11, color: '#378ADD', cursor: 'pointer' }}>
                    ✈ {route.length} сегм. {openTrips[agent.id] ? '▲' : '▼'}
                  </span>
                )}
              </div>
              <button onClick={() => { setOpenId(openId === agent.id ? null : agent.id); resetForm() }} style={{ fontSize: 12, padding: '4px 10px', borderRadius: 6, border: 'none', background: openId === agent.id ? '#e8e8e5' : '#1a1a1a', color: openId === agent.id ? '#444' : 'white', cursor: 'pointer' }}>
                {openId === agent.id ? 'Закрыть' : '+ Поездка'}
              </button>
            </div>
            {route.length > 0 && openTrips[agent.id] && (
              <div style={{ padding: '0 14px 10px', borderTop: '1px solid #f5f5f3' }}>
                {route.map((p, i) => (
                  <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, padding: '6px 0', borderBottom: '0.5px solid #f5f5f3', alignItems: 'center' }}>
                    <div style={{ color: '#444', flex: 1, minWidth: 0 }}>
                      {p.transport_type === 'автобус' ? '🚌' : '✈'} {p.from} → {p.to}
                      {p.from_date && <span style={{ color: '#aaa', marginLeft: 6 }}>{String(p.from_date).slice(0,10).split('-').reverse().join('.')}</span>}
                      {p.files && p.files.length > 0 && <a href={p.files[0].url} target="_blank" rel="noreferrer" style={{ marginLeft: 6, fontSize: 11, color: '#185FA5', textDecoration: 'none' }}>📎 {p.files[0].name}</a>}
                    </div>
                    <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                      <button onClick={() => handleStartEdit(agent, i)} title="Редактировать" style={{ fontSize: 12, padding: '2px 7px', borderRadius: 5, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#555' }}>✏</button>
                      <button onClick={() => handleDeleteRoute(agent, i)} title="Удалить" style={{ fontSize: 12, padding: '2px 7px', borderRadius: 5, border: '1px solid #fca5a5', background: '#fff5f5', cursor: 'pointer', color: '#E24B4A' }}>✕</button>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {openId === agent.id && (
              <div style={{ padding: '0 14px 14px', borderTop: '1px solid #f0f0ec' }}>
                {/* Тип транспорта */}
                <div style={{ display: 'flex', gap: 6, marginTop: 12 }}>
                  {['автобус', 'авиа'].map(type => (
                    <button key={type} onClick={() => setTransportType(type)}
                      style={{ flex: 1, padding: '7px 0', borderRadius: 8, border: '2px solid', fontSize: 13, fontWeight: 600, cursor: 'pointer',
                        borderColor: transportType === type ? '#1a1a1a' : '#e0e0dc',
                        background: transportType === type ? '#1a1a1a' : 'white',
                        color: transportType === type ? 'white' : '#888' }}>
                      {type === 'авиа' ? '✈️ Авиабилет' : '🚌 Автобус'}
                    </button>
                  ))}
                </div>
                {segments.map((seg, idx) => (
                  <div key={idx} style={{ background: '#fafaf8', borderRadius: 8, padding: 10, marginTop: 10, marginBottom: 6 }}>
                    <div style={{ fontSize: 11, fontWeight: 600, color: '#888', marginBottom: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span>{idx === 0 ? 'Маршрут' : 'Стыковка ' + idx}</span>
                      {idx > 0 && <button onClick={() => removeSegment(idx)} style={{ fontSize: 12, color: '#bbb', background: 'none', border: 'none', cursor: 'pointer', padding: '0 2px', lineHeight: 1 }}>✕</button>}
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
                      <div><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Откуда</div><input list="agent-cities-list" value={seg.from} onChange={e => setSeg(idx, 'from', e.target.value)} style={inp} /></div>
                      <div><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Куда</div><input list="agent-cities-list" value={seg.to} onChange={e => setSeg(idx, 'to', e.target.value)} style={inp} /></div>
                      <div><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>{transportType === 'автобус' ? 'Дата отъезда' : 'Дата вылета'}</div><input type="date" value={seg.departure_date} onChange={e => setSeg(idx, 'departure_date', e.target.value)} style={inp} /></div>
                      <div><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>{transportType === 'автобус' ? 'Время отъезда' : 'Время вылета'}</div><input type="time" value={seg.departure_time} onChange={e => setSeg(idx, 'departure_time', e.target.value)} style={inp} /></div>
                      <div><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>{transportType === 'автобус' ? 'Дата приезда' : 'Дата прилёта'}</div><input type="date" value={seg.arrival_date} onChange={e => setSeg(idx, 'arrival_date', e.target.value)} style={inp} /></div>
                      <div><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>{transportType === 'автобус' ? 'Время приезда' : 'Время прилёта'}</div><input type="time" value={seg.arrival_time} onChange={e => setSeg(idx, 'arrival_time', e.target.value)} style={inp} /></div>
                      <div><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Часовой пояс откуда</div><select value={seg.from_tz} onChange={e => setSeg(idx, 'from_tz', e.target.value)} style={inp}>{TRIP_TIMEZONES.map(tz => <option key={tz.value} value={tz.value}>{tz.label}</option>)}</select></div>
                      <div><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Часовой пояс куда</div><select value={seg.to_tz} onChange={e => setSeg(idx, 'to_tz', e.target.value)} style={inp}>{TRIP_TIMEZONES.map(tz => <option key={tz.value} value={tz.value}>{tz.label}</option>)}</select></div>
                    </div>
                  </div>
                ))}
                <button onClick={addSegment} style={{ fontSize: 12, padding: '4px 12px', borderRadius: 6, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', marginTop: 4, marginBottom: 8 }}>+ Стыковка</button>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 10 }}>
                  <div><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Номер билета</div><input value={ticketNumber} onChange={e => setTicketNumber(e.target.value)} style={inp} /></div>
                  <div><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Стоимость (₽)</div><input type="text" inputMode="numeric" value={price} onChange={e => setPrice(e.target.value.replace(/[^0-9.]/g, ''))} style={inp} /></div>
                  <div><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Дата покупки</div><input type="date" value={purchaseDate} onChange={e => setPurchaseDate(e.target.value)} style={inp} /></div>
                  <div><div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Способ оплаты</div><input value={paymentMethod} onChange={e => setPaymentMethod(e.target.value)} placeholder="Карта, наличные, перевод..." style={inp} /></div>
                </div>
                <div style={{ marginBottom: 10 }}>
                  <label style={{ display: 'inline-block', fontSize: 12, padding: '6px 12px', border: '1px dashed #d0d0cc', borderRadius: 7, cursor: 'pointer', color: '#888' }}>
                    📎 {tripFile ? tripFile.name : 'Прикрепить файл билета'}
                    <input type="file" accept="image/*,.pdf" onChange={e => setTripFile(e.target.files[0])} style={{ display: 'none' }} />
                  </label>
                </div>
                <label style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 13, cursor: 'pointer', marginBottom: 10, userSelect: 'none' }}>
                  <input type="checkbox" checked={deductAdvance} onChange={e => setDeductAdvance(e.target.checked)} />
                  <span style={{ color: deductAdvance ? '#E24B4A' : '#555' }}>💳 Вычесть стоимость из аванса</span>
                </label>
                <button onClick={() => handleAdd(agent)} disabled={saving} style={{ width: '100%', padding: '8px', borderRadius: 8, background: '#1a1a1a', color: 'white', border: 'none', cursor: 'pointer', fontSize: 13 }}>
                  {saving ? 'Сохранение...' : editRouteIdx !== null ? 'Сохранить изменения' : 'Добавить поездку'}
                </button>
                <datalist id="agent-cities-list">
                  {cities.map(city => <option key={city.id || city.name} value={city.name} />)}
                </datalist>
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}

function AgentBookingSection({ agents, onRefresh }) {
  const [openId, setOpenId] = useState(null)
  const [openList, setOpenList] = useState({})
  const [form, setForm] = useState({ hotel: '', check_in: '', check_out: '', price: '', notes: '' })
  const [file, setFile] = useState(null)
  const [deductAdvance, setDeductAdvance] = useState(false)
  const [saving, setSaving] = useState(false)
  const inp = { width: '100%', fontSize: 13, padding: '7px 10px', borderRadius: 8, border: '1px solid #e0e0dc', boxSizing: 'border-box' }

  function fmtDate(d) { return d ? String(d).slice(0,10).split('-').reverse().join('.') : '—' }

  async function handleAdd(agent) {
    if (!form.hotel) { alert('Введите название отеля'); return }
    setSaving(true)
    try {
      let fileData = null
      if (file) fileData = await uploadAgentFile(agent.id, 'hotel', file)
      const price = form.price ? parseFloat(form.price) : 0
      const booking = { ...form, price, file: fileData, id: Date.now() }
      const freshA = await fetchAgentById(agent.id)
      const updates = { hotel_bookings: [...(freshA.hotel_bookings || []), booking] }
      if (price > 0) {
        const expComment = form.hotel + (form.check_in ? ' c ' + fmtDate(form.check_in) : '') + (form.check_out ? ' по ' + fmtDate(form.check_out) : '')
        const newExp = { category: deductAdvance ? 'Вычет из аванса' : 'Отель/жильё', amount: price, date: form.check_in || new Date().toISOString().split('T')[0], comment: expComment, file: fileData, id: Date.now() + 1 }
        updates.expenses = [...(freshA.expenses || []), newExp]
      }
      await updateAgent(agent.id, updates)
      setForm({ hotel: '', check_in: '', check_out: '', price: '', notes: '' })
      setFile(null)
      setDeductAdvance(false)
      setOpenId(null)
      onRefresh()
    } catch (e) { alert('Ошибка: ' + e.message) }
    finally { setSaving(false) }
  }

  return (
    <div>
      {agents.map(agent => {
        const bookings = agent.hotel_bookings || []
        return (
          <div key={agent.id} style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 10, marginBottom: 8, overflow: 'hidden' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 14px' }}>
              <div>
                <div style={{ fontWeight: 500, fontSize: 13 }}>{agent.name}</div>
                {bookings.length > 0 && (
                  <span onClick={() => setOpenList(p => ({ ...p, [agent.id]: !p[agent.id] }))} style={{ fontSize: 11, color: '#378ADD', cursor: 'pointer' }}>
                    🏨 {bookings.length} бронир. {openList[agent.id] ? '▲' : '▼'}
                  </span>
                )}
              </div>
              <button onClick={() => setOpenId(openId === agent.id ? null : agent.id)} style={{ fontSize: 12, padding: '4px 10px', borderRadius: 6, border: 'none', background: openId === agent.id ? '#e8e8e5' : '#1a1a1a', color: openId === agent.id ? '#444' : 'white', cursor: 'pointer' }}>
                {openId === agent.id ? 'Закрыть' : '+ Бронь'}
              </button>
            </div>
            {bookings.length > 0 && openList[agent.id] && (
              <div style={{ padding: '0 14px 10px', borderTop: '1px solid #f5f5f3' }}>
                {bookings.map((b, i) => (
                  <div key={i} style={{ padding: '6px 0', borderBottom: '0.5px solid #f5f5f3', fontSize: 12 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
                      <span style={{ fontWeight: 500 }}>🏨 {b.hotel || b.hotel_name || '—'}</span>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
                        {b.price > 0 && <span style={{ fontWeight: 600, color: '#378ADD' }}>{parseFloat(b.price).toLocaleString('ru-RU')} ₽</span>}
                        <button onClick={async () => {
                          if (!window.confirm('Удалить бронирование?')) return
                          const freshA = await fetchAgentById(agent.id)
                          const updated = (freshA.hotel_bookings || []).filter((_, j) => j !== i)
                          const upd = { hotel_bookings: updated }
                          if (parseFloat(b.price) > 0) {
                            const expComment = b.hotel + (b.check_in ? ' c ' + fmtDate(b.check_in) : '') + (b.check_out ? ' по ' + fmtDate(b.check_out) : '')
                            upd.expenses = (freshA.expenses || []).filter(e => !(e.category === 'Отель/жильё' && e.comment === expComment))
                          }
                          await updateAgent(agent.id, upd)
                          onRefresh()
                        }} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ccc', fontSize: 14, lineHeight: 1, padding: '0 2px' }} title="Удалить">✕</button>
                      </div>
                    </div>
                    <div style={{ color: '#888', fontSize: 11, marginTop: 2, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                      {b.check_in && <span>Заезд: {fmtDate(b.check_in)}</span>}
                      {b.check_out && <span>Выезд: {fmtDate(b.check_out)}</span>}
                      {b.notes && <span style={{ color: '#aaa' }}>{b.notes}</span>}
                      {b.file && <a href={b.file.url} target="_blank" rel="noreferrer" style={{ color: '#185FA5', textDecoration: 'none' }}>📎 {b.file.name}</a>}
                    </div>
                  </div>
                ))}
              </div>
            )}
            {openId === agent.id && (
              <div style={{ padding: '0 14px 14px', borderTop: '1px solid #f0f0ec' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 12, marginBottom: 8 }}>
                  <div style={{ gridColumn: '1/-1' }}><div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Отель / жильё *</div>
                    <input value={form.hotel} onChange={e => setForm(f => ({ ...f, hotel: e.target.value }))} style={inp} /></div>
                  <div><div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Заезд</div>
                    <input type="date" value={form.check_in} onChange={e => setForm(f => ({ ...f, check_in: e.target.value }))} style={inp} /></div>
                  <div><div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Выезд</div>
                    <input type="date" value={form.check_out} onChange={e => setForm(f => ({ ...f, check_out: e.target.value }))} style={inp} /></div>
                  <div><div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Стоимость (₽)</div>
                    <input inputMode="numeric" value={form.price} onChange={e => setForm(f => ({ ...f, price: e.target.value.replace(/[^0-9.]/g, '') }))} placeholder="0" style={inp} /></div>
                  <div><div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Файл</div>
                    <label style={{ display: 'inline-block', fontSize: 12, padding: '6px 10px', border: '1px dashed #d0d0cc', borderRadius: 7, cursor: 'pointer', color: '#888', marginTop: 2 }}>
                      📎 {file ? file.name : 'Прикрепить'}
                      <input type="file" onChange={e => setFile(e.target.files[0])} style={{ display: 'none' }} />
                    </label></div>
                  <div style={{ gridColumn: '1/-1' }}><div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Заметки</div>
                    <input value={form.notes} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} placeholder="..." style={inp} /></div>
                </div>
                <label style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 13, cursor: 'pointer', margin: '10px 0', userSelect: 'none' }}>
                  <input type="checkbox" checked={deductAdvance} onChange={e => setDeductAdvance(e.target.checked)} />
                  <span style={{ color: deductAdvance ? '#E24B4A' : '#555' }}>💳 Вычесть стоимость из аванса</span>
                </label>
                <button onClick={() => handleAdd(agent)} disabled={saving} style={{ width: '100%', padding: '8px', borderRadius: 8, background: '#1a1a1a', color: 'white', border: 'none', cursor: 'pointer', fontSize: 13 }}>
                  {saving ? 'Сохранение...' : 'Добавить бронирование'}
                </button>
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}

function GeoButton({ candidateId, candidate }) {
  const [loading, setLoading] = useState(false)
  const [loc, setLoc] = useState(null)
  const [showMap, setShowMap] = useState(false)

  useEffect(() => {
    getCandidateLocation(candidateId).then(setLoc)
    const interval = setInterval(() => getCandidateLocation(candidateId).then(setLoc), 30000)
    return () => clearInterval(interval)
  }, [candidateId])

  async function handleShare() {
    setLoading(true)
    try {
      const row = await getOrCreateGeoToken(candidateId)
      setLoc(row)
      const link = `https://krasnoebeloeoblako.site/geo/${row.token}`
      window.prompt('Скопируйте ссылку и отправьте кандидату:', link)
    } catch(e) {
      alert('Ошибка: ' + e.message)
    } finally {
      setLoading(false)
    }
  }

  const hasLocation = loc?.lat && loc?.lng
  const updatedAt = loc?.updated_at ? new Date(loc.updated_at) : null
  const isRecent = updatedAt && (Date.now() - updatedAt.getTime()) < 10 * 60 * 1000

  return (
    <>
      <div style={{ display: 'flex', gap: 0 }}>
        <button
          onClick={handleShare}
          disabled={loading}
          title="Отправить ссылку кандидату"
          style={{
            fontSize: 12, padding: '4px 8px', cursor: 'pointer',
            borderRadius: hasLocation ? '6px 0 0 6px' : '6px',
            border: `1px solid ${isRecent ? '#22c55e' : '#e0e0dc'}`,
            borderRight: hasLocation ? 'none' : undefined,
            background: isRecent ? '#f0fdf4' : 'white',
            color: '#555',
          }}
        >
          📍
        </button>
        {hasLocation && (
          <button
            onClick={() => setShowMap(true)}
            title="Посмотреть на карте"
            style={{
              fontSize: 11, padding: '4px 8px', borderRadius: '0 6px 6px 0', cursor: 'pointer',
              border: `1px solid ${isRecent ? '#22c55e' : '#e0e0dc'}`,
              background: isRecent ? '#f0fdf4' : '#f8f8f6',
              color: isRecent ? '#16a34a' : '#b45309',
              fontWeight: 600,
            }}
          >
            {isRecent ? 'онлайн' : 'был'}
          </button>
        )}
      </div>
      {showMap && <GeoMapModal candidate={candidate} onClose={() => setShowMap(false)} />}
    </>
  )
}

export default function ProfilePage({ darkMode, session, userProfile, isAdmin, isOperator, isViewer, isMoscowOperator, candidates, locations, onClose, onRefresh, onOpenCandidate, onEditCandidate, onAddCandidate, onAddTrip, onAddExpense, onOpenAnalytics, onUnarchive, workspace = 'main', canSeeAgents = true }) {
  const defaultSection = isMoscowOperator ? 'moscow' : 'candidates'
  const [activeSection, setActiveSection] = useState(() => {
    const saved = localStorage.getItem('profileActiveSection')
    return saved && saved !== 'agent_kanban' ? saved : defaultSection   // «Этапы» убраны 22.10.2026
  })
const [users, setUsers] = useState([])
  const [usersLoading, setUsersLoading] = useState(false)
  const [agents, setAgents] = useState([])
  const [sectionEntity, setSectionEntity] = useState({}) // { add_expense: 'candidate'|'agent', ... }
  const [locationFilter, setLocationFilter] = useState('')
  const [search, setSearch] = useState('')
  const [candidateSearch, setCandidateSearch] = useState('')
  const [respFilter, setRespFilter] = useState('')
  const [extraCandidates, setExtraCandidates] = useState([])
  const [extraLoaded, setExtraLoaded] = useState({ archive: false, completed: false, partner_completed: false })
  const [extraLoading, setExtraLoading] = useState(false)
  const [completedSearch, setCompletedSearch] = useState('')
  const [completedPayFilter, setCompletedPayFilter] = useState('all')
  const [moscowSearch, setMoscowSearch] = useState('')
  const [moscowExpenseForm, setMoscowExpenseForm] = useState(null) // { candidateId, category, amount, comment, date, saving }
  const [agentKanbanCard, setAgentKanbanCard] = useState(null) // открытая карточка
  const [agentNoteInput, setAgentNoteInput] = useState('')
  const [agentNoteFiles, setAgentNoteFiles] = useState([]) // { name, url } прикреплённые к заметке файлы
  const [agentNoteUploading, setAgentNoteUploading] = useState(false)
  const [contractorExportOpen, setContractorExportOpen] = useState(false)
  const [contractorExporting, setContractorExporting] = useState(false)
  useEffect(() => {
    fetchContractorExportStatus().then(d => setContractorExportOpen(!!d?.open)).catch(() => {})
  }, [])
  const handleContractorExport = async () => {
    if (contractorExporting) return
    if (!window.confirm('Выгрузить всех ваших кандидатов (и архивных) с документами в файл для CRM подрядчика?\n\nФайл нужен только для загрузки в ваш кабинет в CRM подрядчика — не пересылайте его и удалите после загрузки.')) return
    setContractorExporting(true)
    try { await downloadMyCandidatesExport() }
    catch (e) { alert(e.message) }
    finally { setContractorExporting(false) }
  }
  const [agentKanbanSearch, setAgentKanbanSearch] = useState('')
  const agentSearchRef = React.useRef(null)
  const [agentKanbanDetailOpen, setAgentKanbanDetailOpen] = useState(false) // открыть DetailModal для редактирования
  const [agentCardTasks, setAgentCardTasks] = useState([])
  const [agentCardTaskInput, setAgentCardTaskInput] = useState('')
  const [agentCardTaskSaving, setAgentCardTaskSaving] = useState(false)
  const [agentCardTaskForm, setAgentCardTaskForm] = useState({ title: '', description: '', due_date: '', priority: 'normal' })
  const [agentCardTaskFormOpen, setAgentCardTaskFormOpen] = useState(false)
  const [agentCardMobileTab, setAgentCardMobileTab] = useState('notes')
  const [agentCountries, setAgentCountries] = useState([])
  const [agentCountryTab, setAgentCountryTab] = useState('all')
  const [agentCountryAdding, setAgentCountryAdding] = useState(false)
  const [agentCountryInput, setAgentCountryInput] = useState('')
  const [agentStageEditing, setAgentStageEditing] = useState(null) // { country } объект из agentCountries
  const [agentAdvances, setAgentAdvances] = useState([])
  const [advanceForm, setAdvanceForm] = useState({ agent_id: '', agent_name: '', amount: '', currency: 'USD', note: '' })
  const [advanceSaving, setAdvanceSaving] = useState(false)
  const [agentStageEditList, setAgentStageEditList] = useState([]) // ['Этап1', ...]
  const [waOpen, setWaOpen] = useState(false)
  const [waMessages, setWaMessages] = useState([])
  const [waInput, setWaInput] = useState('')
  const [waSending, setWaSending] = useState(false)
  const [waLoading, setWaLoading] = useState(false)
  const waPollingRef = React.useRef(null)
  const waBottomRef = React.useRef(null)
  const [waPhone, setWaPhone] = useState('')
  const [waChannels, setWaChannels] = useState([])
  const [waChannelId, setWaChannelId] = useState(null)
  const [agentCardTaskFormSaving, setAgentCardTaskFormSaving] = useState(false)
  const [agentEditingNoteId, setAgentEditingNoteId] = useState(null) // id редактируемой заметки
  const [agentEditInput, setAgentEditInput] = useState('')
  const [agentNoteMenuId, setAgentNoteMenuId] = useState(null) // id заметки с открытым меню ⋯
  const [agentCandidates, setAgentCandidates] = useState([])
  const [agentQuickForm, setAgentQuickForm] = useState({ name: '', passport: '', phone: '', responsible_id: '', responsible_name: '' })
  const [agentQuickSaving, setAgentQuickSaving] = useState(false)
  const [agentRespFilter, setAgentRespFilter] = useState('')
  const [tasks, setTasks] = useState([])
  const [tasksLoading, setTasksLoading] = useState(false)
  const [taskForm, setTaskForm] = useState({ title: '', description: '', due_date: '', priority: 'normal', candidate_id: null, candidate_name: '' })
  const [taskFormOpen, setTaskFormOpen] = useState(false)
  const [taskSaving, setTaskSaving] = useState(false)
  const [taskFilter, setTaskFilter] = useState('open')
  const [taskSearchQuery, setTaskSearchQuery] = useState('')
  const [taskCandidateSearch, setTaskCandidateSearch] = useState('')
  const [taskCandidateOpen, setTaskCandidateOpen] = useState(false)
  const [taskMenuId, setTaskMenuId] = useState(null)
  const [taskEditingId, setTaskEditingId] = useState(null)
  const [taskEditForm, setTaskEditForm] = useState({ title: '', description: '', due_date: '', priority: 'normal' })

  async function loadTasks() {
    setTasksLoading(true)
    try { setTasks(await fetchTasks(userProfile?.full_name !== 'Анна', workspace)) }
    catch(e) {}
    finally { setTasksLoading(false) }
  }

  async function handleAddTask() {
    if (!taskForm.title.trim()) return
    setTaskSaving(true)
    try {
      await addTask({ title: taskForm.title.trim(), description: taskForm.description.trim(), due_date: taskForm.due_date || null, priority: taskForm.priority, candidate_id: taskForm.candidate_id || null, candidate_name: taskForm.candidate_name || null })
      setTaskForm({ title: '', description: '', due_date: '', priority: 'normal', candidate_id: null, candidate_name: '' })
      setTaskCandidateSearch('')
      setTaskFormOpen(false)
      await loadTasks()
    } catch(e) { alert('Ошибка: ' + e.message) }
    finally { setTaskSaving(false) }
  }

  async function handleCompleteTask(task) {
    await updateTask(task.id, { status: 'done', completed_at: new Date().toISOString() })
    setTasks(prev => prev.map(t => t.id === task.id ? { ...t, status: 'done' } : t))
  }

  async function handleReopenTask(task) {
    await updateTask(task.id, { status: 'open', completed_at: null })
    setTasks(prev => prev.map(t => t.id === task.id ? { ...t, status: 'open' } : t))
  }

  async function handleDeleteTask(task) {
    if (!window.confirm('Удалить задачу?')) return
    await deleteTask(task.id)
    setTasks(prev => prev.filter(t => t.id !== task.id))
  }

  async function handlePinTask(task) {
    await updateTask(task.id, { pinned: !task.pinned })
    setTasks(prev => prev.map(t => t.id === task.id ? { ...t, pinned: !t.pinned } : t))
    setTaskMenuId(null)
  }

  async function handleSaveEditTask(task) {
    await updateTask(task.id, { title: taskEditForm.title.trim(), description: taskEditForm.description.trim(), due_date: taskEditForm.due_date || null, priority: taskEditForm.priority })
    setTasks(prev => prev.map(t => t.id === task.id ? { ...t, ...taskEditForm, title: taskEditForm.title.trim(), description: taskEditForm.description.trim() } : t))
    setTaskEditingId(null)
  }
  const [sendToCRMCandidate, setSendToCRMCandidate] = useState(null) // кандидат ожидающий выбора локации
  const [sendToCRMLocation, setSendToCRMLocation] = useState('')

  async function loadAgentCandidates() {
    const data = await fetchAgentCandidates(workspace)
    setAgentCandidates(data)
  }

  useEffect(() => {
    if (activeSection === 'agent_kanban') { loadAgentCandidates(); fetchAgentCountries().then(setAgentCountries).catch(() => {}) }
    if (activeSection === 'agent_advances') { fetchAgentAdvances().then(setAgentAdvances).catch(() => {}); fetchAgents().then(setAgents).catch(() => {}) }
    if (activeSection === 'tasks') loadTasks()
  }, [activeSection])


  // Авто-обновление Этапов каждые 15 сек (новые кандидаты из WhatsApp)
  const agentKanbanPollingRef = React.useRef(null)
  const agentKanbanCardRef = React.useRef(null)
  React.useEffect(() => { agentKanbanCardRef.current = agentKanbanCard }, [agentKanbanCard])
  const pendingAgentDataRef = React.useRef(null)
  useEffect(() => {
    if (activeSection !== 'agent_kanban') { clearInterval(agentKanbanPollingRef.current); return }
    agentKanbanPollingRef.current = setInterval(() => {
      fetchAgentCandidates(workspace).then(data => {
        if (agentKanbanCardRef.current) {
          pendingAgentDataRef.current = data
          return
        }
        setAgentCandidates(prev => {
          if (data.length !== prev.length) return data
          const hasChanges = data.some(d => {
            const old = prev.find(p => p.id === d.id)
            return !old || old.wa_unread_count !== d.wa_unread_count || old.wa_last_direction !== d.wa_last_direction || JSON.stringify(old.wa_last_direction_by_channel) !== JSON.stringify(d.wa_last_direction_by_channel) || old.open_task_count !== d.open_task_count || old.agent_stage !== d.agent_stage || old.name !== d.name || old.location_id !== d.location_id || old.citizenship !== d.citizenship || old.agent_notes !== d.agent_notes
          })
          return hasChanges ? data : prev
        })
      }).catch(() => {})
    }, 5000)
    return () => clearInterval(agentKanbanPollingRef.current)
  }, [activeSection])

  async function loadSection(section) {
    if (section === 'archive' && !extraLoaded.archive) {
      setExtraLoading(true)
      try {
        const data = await fetchArchivedCandidates(workspace)
        setExtraCandidates(prev => {
          const ids = new Set(prev.map(c => c.id))
          return [...prev, ...data.filter(c => !ids.has(c.id))]
        })
        setExtraLoaded(prev => ({ ...prev, archive: true }))
      } finally { setExtraLoading(false) }
    } else if (section === 'completed' && !extraLoaded.completed) {
      setExtraLoading(true)
      try {
        const data = await fetchCompletedCandidates(workspace)
        setExtraCandidates(prev => {
          const ids = new Set(prev.map(c => c.id))
          return [...prev, ...data.filter(c => !ids.has(c.id))]
        })
        setExtraLoaded(prev => ({ ...prev, completed: true }))
      } finally { setExtraLoading(false) }
    } else if (section === 'partner_completed' && !extraLoaded.partner_completed) {
      setExtraLoading(true)
      try {
        const data = await fetchPartnerCompletedCandidates(workspace)
        setExtraCandidates(prev => {
          const ids = new Set(prev.map(c => c.id))
          return [...prev, ...data.filter(c => !ids.has(c.id))]
        })
        setExtraLoaded(prev => ({ ...prev, partner_completed: true }))
      } finally { setExtraLoading(false) }
    }
    setActiveSection(section)
    localStorage.setItem('profileActiveSection', section)
  }

  // Сохранять секцию в localStorage при обычном setActiveSection
  const setActiveSectionPersist = (section) => {
    setActiveSection(section)
    localStorage.setItem('profileActiveSection', section)
  }

  const candidateIds = new Set(candidates.map(c => c.id))
  const allCandidates = [...candidates, ...extraCandidates.filter(c => !candidateIds.has(c.id))]
  const moscowLocationIds = locations.filter(l => l.timezone === 'Europe/Moscow' || l.name?.toLowerCase().includes('москва')).map(l => l.id)
  const myCandidates = (isAdmin || isMoscowOperator || isViewer)
    ? allCandidates.filter(c => isMoscowOperator ? moscowLocationIds.includes(c.location_id) : true)
    : userProfile?.full_name === 'Тима'
      ? allCandidates.filter(c => c.responsible_id === '11b913dc-4a9f-4f60-8d05-d00b5cb2185f')   // учётка «Тима (бывш. «Никита»)»
      : allCandidates.filter(c => c.responsible_id === session?.user?.id)
  const activeCandidates = myCandidates.filter(c => !c.archived && c.status !== 'завершен' && !c.moscow_completed)
  const responsibleNames = [...new Set(myCandidates.map(c => c.responsible_name).filter(Boolean))].sort()

  const filteredCandidates = activeCandidates.filter(c => {
    if (locationFilter && c.location_id !== locationFilter) return false
    if ((isAdmin || isViewer) && respFilter && c.responsible_name !== respFilter) return false
    if (candidateSearch) {
      const q = candidateSearch.toLowerCase()
      const numQ = q.replace(/\D/g, '')
      const matchPhone = numQ.length > 0 && (c.phone || '').replace(/\D/g, '').includes(numQ)
      return c.name?.toLowerCase().includes(q) || c.passport?.toLowerCase().includes(q) || matchPhone
    }
    return true
  }).sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0))
React.useEffect(() => {
    if (activeSection === 'users' || activeSection === 'agent_kanban') {
      setUsersLoading(true)
      fetchUserProfiles().then(data => { setUsers(data); setUsersLoading(false) }).catch(() => setUsersLoading(false))
    }
  }, [activeSection])

  React.useEffect(() => {
    fetchAgents().then(setAgents).catch(() => {})
  }, [])

  React.useEffect(() => {
    if (!session) return
    Promise.all([
      fetchArchivedCandidates(workspace),
      fetchCompletedCandidates(workspace),
    ]).then(([archived, completed]) => {
      const seen = new Set()
      const merged = [...archived, ...completed].filter(c => {
        if (seen.has(c.id)) return false
        seen.add(c.id)
        return true
      })
      setExtraCandidates(merged)
      setExtraLoaded({ archive: true, completed: true })
    }).catch(() => {})
  }, [session, workspace])

  // Загружать задачи и свежие данные кандидата при открытии карточки в Этапах
  React.useEffect(() => {
    if (!agentKanbanCard?.id) { setAgentCardTasks([]); return }
    fetchCandidateTasks(agentKanbanCard.id).then(setAgentCardTasks).catch(() => {})
    fetchCandidateById(agentKanbanCard.id).then(fresh => {
      if (!fresh) return
      setAgentCandidates(prev => prev.map(c => c.id === fresh.id ? { ...c, ...fresh } : c))
    }).catch(() => {})
  }, [agentKanbanCard?.id])

  // Загрузка каналов WhatsApp
  React.useEffect(() => {
    fetchWhatsappChannels().then(chs => {
      setWaChannels(chs || [])
      if (!waChannelId && chs?.length) setWaChannelId(chs[0].channel_id)
    }).catch(() => {})
  }, [])

  // WhatsApp polling при открытом чате
  const effectiveWaPhone = waPhone || agentKanbanCard?.phone || ''
  const waPrevCountRef = React.useRef(0)
  React.useEffect(() => {
    if (!waOpen || !effectiveWaPhone) { clearInterval(waPollingRef.current); waPrevCountRef.current = 0; return }
    const load = async (forceScroll = false) => {
      try {
        const msgs = await fetchWhatsappHistory(effectiveWaPhone, waChannelId)
        setWaMessages(msgs)
        if (forceScroll || msgs.length > waPrevCountRef.current) {
          waPrevCountRef.current = msgs.length
          setTimeout(() => waBottomRef.current?.scrollIntoView({ behavior: 'smooth' }), 50)
        }
      } catch(e) {}
    }
    load(true)
    waPollingRef.current = setInterval(() => load(false), 5000)
    return () => clearInterval(waPollingRef.current)
  }, [waOpen, effectiveWaPhone, waChannelId])

  // Блокировать скролл страницы когда открыта карточка кандидата в Этапах
  const agentModalRef = React.useRef(null)
  React.useEffect(() => {
    if (!agentKanbanCard) return
    const prevent = e => {
      if (!agentModalRef.current) return
      // Разрешаем скролл внутри любого scrollable элемента модалки
      let el = e.target
      while (el && el !== document.body) {
        if (el === agentModalRef.current) return // внутри модалки — разрешаем
        el = el.parentElement
      }
      e.preventDefault()
    }
    document.addEventListener('touchmove', prevent, { passive: false })
    return () => document.removeEventListener('touchmove', prevent)
  }, [agentKanbanCard])

  function entityToggle(section) {
    const current = sectionEntity[section] || 'candidate'
    return (
      <div style={{ display: 'flex', background: '#f0f0ec', borderRadius: 8, padding: 3, gap: 3, marginBottom: 16, width: 'fit-content' }}>
        {['candidate', 'agent'].map(type => (
          <button key={type} onClick={() => setSectionEntity(s => ({ ...s, [section]: type }))}
            style={{ fontSize: 12, padding: '5px 14px', borderRadius: 6, border: 'none', cursor: 'pointer', background: current === type ? 'white' : 'transparent', fontWeight: current === type ? 600 : 400, color: current === type ? '#1a1a1a' : '#888', boxShadow: current === type ? '0 1px 4px rgba(0,0,0,0.08)' : 'none' }}>
            {type === 'candidate' ? '👤 Кандидаты' : '🤝 Агенты'}
          </button>
        ))}
      </div>
    )
  }
  const dm = darkMode
  const btnStyle = (active) => ({
    fontSize: 13, padding: '7px 16px', borderRadius: 8, border: 'none', cursor: 'pointer',
    background: active ? '#1a1a1a' : '#e8e8e5',
    color: active ? 'white' : '#444',
    fontWeight: active ? 600 : 400
  })
  const btnClass = (active) => active ? 'profile-tab profile-tab-active' : 'profile-tab'

  return (
    <div className={darkMode ? 'dm-page' : ''} style={{ position: 'fixed', inset: 0, background: darkMode ? '#0f1117' : '#f5f5f3', zIndex: 1000, overflowY: 'auto' }}>
      <div style={{ maxWidth: activeSection === 'agent_kanban' ? '100%' : 900, margin: '0 auto', padding: activeSection === 'agent_kanban' ? '24px 24px' : '24px 16px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center' }}><h1 style={{ fontSize: 20, fontWeight: 700, margin: 0, color: darkMode ? '#e2e8f0' : undefined }}>👤 Личный кабинет</h1><SpecialBadge /></div>
            <div style={{ fontSize: 13, color: darkMode ? '#64748b' : '#888', marginTop: 4 }}>{userProfile?.full_name} · {userProfile?.role}</div>
          </div>
          <button className="btn btn-outline" onClick={onClose}>✕ Закрыть</button>
        </div>

        <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
          {!isMoscowOperator && <button onClick={() => setActiveSectionPersist('candidates')} className={btnClass(activeSection === 'candidates')} style={btnStyle(activeSection === 'candidates')}>👥 Кандидаты</button>}
          {!isMoscowOperator && <button onClick={() => setActiveSectionPersist('locations')} className={btnClass(activeSection === 'locations')} style={btnStyle(activeSection === 'locations')}>📍 Локации</button>}
          {(isAdmin || isOperator) && <button onClick={onAddCandidate} className={btnClass(false)} style={btnStyle(false)}>+ Добавить кандидата</button>}
          {(isAdmin || isOperator) && <button onClick={() => setActiveSectionPersist('add_trip')} className={btnClass(activeSection === 'add_trip')} style={btnStyle(activeSection === 'add_trip')}>✈ Поездки</button>}
          {(isAdmin || isOperator) && <button onClick={() => setActiveSectionPersist('add_booking')} className={btnClass(activeSection === 'add_booking')} style={btnStyle(activeSection === 'add_booking')}>🏨 Бронирования</button>}
          {(isAdmin || isOperator) && <button onClick={() => setActiveSectionPersist('add_expense')} className={btnClass(activeSection === 'add_expense')} style={btnStyle(activeSection === 'add_expense')}>💰 Расходы</button>}
          {(isAdmin || isOperator) && <button onClick={() => setActiveSectionPersist('add_visa')} className={btnClass(activeSection === 'add_visa')} style={btnStyle(activeSection === 'add_visa')}>🛂 Визы</button>}
          {(isAdmin || isMoscowOperator) && <button onClick={() => setActiveSectionPersist('moscow')} className={btnClass(activeSection === 'moscow')} style={btnStyle(activeSection === 'moscow')}>🏛 Москва</button>}
          {(isAdmin || userProfile?.full_name === 'Николай') && <button onClick={() => setActiveSectionPersist('tasks')} className={btnClass(activeSection === 'tasks')} style={btnStyle(activeSection === 'tasks')}>📝 Задачи</button>}
          {(isAdmin || isMoscowOperator || isViewer) && <button onClick={() => loadSection('completed')} className={btnClass(activeSection === 'completed')} style={btnStyle(activeSection === 'completed')}>✅ Завершённые</button>}
          {(isAdmin || isMoscowOperator || isViewer) && <button onClick={() => loadSection('partner_completed')} className={btnClass(activeSection === 'partner_completed')} style={btnStyle(activeSection === 'partner_completed')}>🤝 Завершённые партнёрам</button>}
          {(isAdmin || isViewer) && <button onClick={onOpenAnalytics} className={btnClass(false)} style={btnStyle(false)}>📊 Аналитика</button>}
          {!isMoscowOperator && <button onClick={() => loadSection('archive')} className={btnClass(activeSection === 'archive')} style={btnStyle(activeSection === 'archive')}>📦 Архив</button>}
          {isAdmin && userProfile?.full_name !== 'Логист' && !IS_SPECIAL && <button onClick={() => setActiveSectionPersist('users')} className={btnClass(activeSection === 'users')} style={btnStyle(activeSection === 'users')}>👥 Пользователи</button>}
          {(isAdmin || isOperator) && <button onClick={() => setActiveSectionPersist('notifications')} className={btnClass(activeSection === 'notifications')} style={btnStyle(activeSection === 'notifications')}>🔔 Уведомления</button>}
          <button onClick={() => setActiveSectionPersist('templates')} className={btnClass(activeSection === 'templates')} style={btnStyle(activeSection === 'templates')}>📋 Шаблоны</button>
          {(isAdmin || contractorExportOpen) && !isViewer && <button onClick={handleContractorExport} disabled={contractorExporting} className={btnClass(false)} style={btnStyle(false)}>{contractorExporting ? '⏳ Готовлю файл…' : '⬇ Выгрузить моих кандидатов'}</button>}
        </div>

        {activeSection === 'candidates' && (
          <div>
            <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
              <input value={candidateSearch} onChange={e => setCandidateSearch(e.target.value)} placeholder="Поиск по имени или паспорту..." style={{ fontSize: 13, padding: '7px 12px', borderRadius: 8, border: '1px solid #e0e0dc', flex: 1, minWidth: 200 }} />
              <select value={locationFilter} onChange={e => setLocationFilter(e.target.value)} style={{ fontSize: 13, padding: '7px 12px', borderRadius: 8, border: '1px solid #e0e0dc' }}>
                <option value="">Все локации</option>
                {locations.map(l => <option key={l.id} value={l.id}>{l.icon} {l.name}</option>)}
              </select>
              {isAdmin && responsibleNames.length > 0 && (
                <select value={respFilter} onChange={e => setRespFilter(e.target.value)} style={{ fontSize: 13, padding: '7px 12px', borderRadius: 8, border: '1px solid #e0e0dc' }}>
                  <option value="">Все ответственные</option>
                  {responsibleNames.map(n => <option key={n} value={n}>{n}</option>)}
                </select>
              )}
            </div>
            <div style={{ fontSize: 13, color: '#888', marginBottom: 10 }}>
              {isAdmin ? 'Все активные кандидаты' : 'Мои кандидаты'} ({filteredCandidates.length})
            </div>
            {filteredCandidates.length === 0 && <div style={{ color: '#bbb', fontSize: 13, textAlign: 'center', padding: 24 }}>Нет кандидатов</div>}
            {filteredCandidates.map(c => (
              <div key={c.id} style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 10, padding: '12px 16px', marginBottom: 8 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: 14 }}>{c.name}</div>
                    <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{c.passport} · {locations.find(l => l.id === c.location_id)?.name || '—'} · {c.responsible_name || '—'}</div>
                  <div style={{ marginTop: 4 }}>
                    <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 6, background: c.status === 'прибыл' ? '#EAF3DE' : c.status === 'в пути' ? '#FEF3E2' : c.status === 'завершен' ? '#F0EBF8' : '#E8F1FB', color: c.status === 'прибыл' ? '#27500A' : c.status === 'в пути' ? '#633806' : c.status === 'завершен' ? '#4A235A' : '#1A3A5C', fontWeight: 500 }}>
                      {c.status || 'ожидает'}
                    </span>
                  </div>
                  </div>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
                    <select value={c.location_id || ''} onChange={async e => {
                      await updateCandidate(c.id, { location_id: e.target.value })
                      onRefresh()
                    }} style={{ fontSize: 12, padding: '4px 8px', borderRadius: 6, border: '1px solid #e0e0dc' }}>
                      <option value="">— локация —</option>
                      {locations.map(l => <option key={l.id} value={l.id}>{l.icon} {l.name}</option>)}
                    </select>
                    <button onClick={() => onOpenCandidate(c)} style={{ fontSize: 12, padding: '4px 10px', borderRadius: 6, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer' }}>Открыть</button>
                    <GeoButton candidateId={c.id} candidate={c} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
{activeSection === 'add_trip' && (
          <div>
            {entityToggle('add_trip')}
            {(sectionEntity['add_trip'] || 'candidate') === 'candidate' ? (
              <TripInlineSection candidates={filteredCandidates} locations={locations} currentUserId={session?.user?.id} currentUserName={userProfile?.full_name || ''} onSaved={onRefresh} agents={agents} canSeeAgents={canSeeAgents} />
            ) : (
              <AgentRouteSection agents={agents} onRefresh={() => fetchAgents().then(setAgents)} />
            )}
          </div>
        )}
{activeSection === 'add_booking' && (
          <div>
            {entityToggle('add_booking')}
            {(sectionEntity['add_booking'] || 'candidate') === 'candidate' ? (
              <BookingInlineSection candidates={filteredCandidates} locations={locations} currentUserId={session?.user?.id} onRefresh={onRefresh} agents={agents} canSeeAgents={canSeeAgents} />
            ) : (
              <AgentBookingSection agents={agents} onRefresh={() => fetchAgents().then(setAgents)} />
            )}
          </div>
        )}
{activeSection === 'moscow' && (
          <div>
            {(isAdmin || isMoscowOperator) && <StatementImport />}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
              <div style={{ fontSize: 13, color: '#888' }}>Кандидаты в Москве — быстрый доступ к блоку Оформление</div>
              {isAdmin && responsibleNames.length > 0 && (
                <select value={respFilter} onChange={e => setRespFilter(e.target.value)} style={{ fontSize: 13, padding: '5px 10px', borderRadius: 8, border: '1px solid #e0e0dc' }}>
                  <option value="">Все ответственные</option>
                  {responsibleNames.map(n => <option key={n} value={n}>{n}</option>)}
                </select>
              )}
            </div>
            <input
              type="text"
              placeholder="Поиск по имени..."
              value={moscowSearch}
              onChange={e => setMoscowSearch(e.target.value)}
              style={{ width: '100%', boxSizing: 'border-box', padding: '8px 12px', fontSize: 13, border: '1px solid #e0e0dc', borderRadius: 8, marginBottom: 12, outline: 'none' }}
            />
            {filteredCandidates.filter(c => {
              const loc = locations.find(l => l.id === c.location_id)
              return loc?.region === 'МОСКВА' && (!moscowSearch || c.name.toLowerCase().includes(moscowSearch.toLowerCase()))
            }).length === 0 && (
              <div style={{ color: '#bbb', fontSize: 13, textAlign: 'center', padding: 32 }}>Нет кандидатов в Москве</div>
            )}
            {filteredCandidates.filter(c => {
              const loc = locations.find(l => l.id === c.location_id)
              return loc?.region === 'МОСКВА' && (!moscowSearch || c.name.toLowerCase().includes(moscowSearch.toLowerCase()))
            }).map(c => (
              <div key={c.id} style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 10, padding: '12px 16px', marginBottom: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>{c.name}</div>
                  <div style={{ fontSize: 12, color: '#aaa', marginTop: 2 }}>{c.passport} · {c.responsible_name || '—'}</div>
                </div>
                <div style={{ display: 'flex', gap: 6 }}>
                  <button
                    onClick={() => onOpenCandidate(c, 'moscow')}
                    style={{ fontSize: 12, padding: '6px 14px', borderRadius: 6, border: 'none', background: '#1a1a1a', color: 'white', cursor: 'pointer' }}
                  >🏛 Оформление</button>
                  <button
                    onClick={async () => {
                      if (!window.confirm(`Перевести ${c.name} в раздел «Завершённые»?`)) return
                      const completedAt = new Date().toISOString()
                      await updateCandidate(c.id, { moscow_completed: true, moscow_completed_at: completedAt })
                      setExtraCandidates(prev => {
                        const updated = { ...c, moscow_completed: true, moscow_completed_at: completedAt }
                        const ids = new Set(prev.map(x => x.id))
                        return ids.has(c.id) ? prev.map(x => x.id === c.id ? updated : x) : [...prev, updated]
                      })
                      onRefresh()
                    }}
                    style={{ fontSize: 12, padding: '6px 14px', borderRadius: 6, border: '1px solid #639922', background: 'white', color: '#639922', cursor: 'pointer' }}
                  >✅ Завершён</button>
                </div>
              </div>
            ))}
          </div>
        )}
{activeSection === 'completed' && (
          <div>
            {extraLoading && <div style={{ textAlign: 'center', padding: 20, color: '#888', fontSize: 13 }}>Загрузка...</div>}
            <div style={{ fontSize: 13, color: '#888', marginBottom: 10 }}>
              Кандидаты завершившие оформление в Москве — {myCandidates.filter(c => c.moscow_completed).length} чел.
            </div>
            <input
              type="text"
              placeholder="Поиск по имени..."
              value={completedSearch}
              onChange={e => setCompletedSearch(e.target.value)}
              style={{ width: '100%', boxSizing: 'border-box', padding: '8px 12px', fontSize: 13, border: '1px solid #e0e0dc', borderRadius: 8, marginBottom: 8, outline: 'none' }}
            />
            {(() => {
              const allCompleted = myCandidates.filter(c => c.moscow_completed)
              const cntContractors = allCompleted.filter(c => c.paid_by_contractors_at).length
              const cntAgent = allCompleted.filter(c => c.paid_to_agent_at).length
              const cntNone = allCompleted.filter(c => !c.paid_by_contractors_at && !c.paid_to_agent_at).length
              const cntNoAgent = allCompleted.filter(c => !c.paid_to_agent_at).length
              const cntNoContractors = allCompleted.filter(c => !c.paid_by_contractors_at).length
              const chipStyle = (key, color, bg, border) => ({
                fontSize: 12, padding: '5px 12px', borderRadius: 20, border: `1px solid ${completedPayFilter === key ? border : '#e0e0dc'}`,
                background: completedPayFilter === key ? bg : 'white', color: completedPayFilter === key ? color : '#888',
                cursor: 'pointer', whiteSpace: 'nowrap', fontWeight: completedPayFilter === key ? 600 : 400
              })
              return (
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 10 }}>
                  <span style={chipStyle('all', 'white', '#1a2332', '#1a2332')} onClick={() => setCompletedPayFilter('all')}>Все ({allCompleted.length})</span>
                  <span style={chipStyle('contractors', '#3B6D11', '#EAF3DE', '#639922')} onClick={() => setCompletedPayFilter('contractors')}>✓ Оплачен контрагентами ({cntContractors})</span>
                  <span style={chipStyle('no_contractors', '#1a4d00', '#e8f5e2', '#388e3c')} onClick={() => setCompletedPayFilter('no_contractors')}>✗ Не оплатили контрагенты ({cntNoContractors})</span>
                  <span style={chipStyle('agent', '#0C447C', '#E6F1FB', '#185FA5')} onClick={() => setCompletedPayFilter('agent')}>✓ Оплатил агенту ({cntAgent})</span>
                  <span style={chipStyle('no_agent', '#7a1f00', '#fde8e4', '#d84315')} onClick={() => setCompletedPayFilter('no_agent')}>✗ Не оплатил агенту ({cntNoAgent})</span>
                  <span style={chipStyle('none', '#7a5000', '#fff3cd', '#e8a000')} onClick={() => setCompletedPayFilter('none')}>⏳ Не оплачен ({cntNone})</span>
                </div>
              )
            })()}
            {myCandidates.filter(c => c.moscow_completed).length === 0 && (
              <div style={{ color: '#bbb', fontSize: 13, textAlign: 'center', padding: 32 }}>Завершённых кандидатов нет</div>
            )}
            {myCandidates.filter(c => {
              if (!c.moscow_completed) return false
              if (completedSearch && !c.name.toLowerCase().includes(completedSearch.toLowerCase())) return false
              if (completedPayFilter === 'contractors') return !!c.paid_by_contractors_at
              if (completedPayFilter === 'no_contractors') return !c.paid_by_contractors_at
              if (completedPayFilter === 'agent') return !!c.paid_to_agent_at
              if (completedPayFilter === 'no_agent') return !c.paid_to_agent_at
              if (completedPayFilter === 'none') return !c.paid_by_contractors_at && !c.paid_to_agent_at
              return true
            }).map(c => (
              <div key={c.id} style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 10, padding: '12px 16px', marginBottom: 8 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <span style={{ fontWeight: 600, fontSize: 14 }}>{c.name}</span>
                      <span style={{ fontSize: 11, color: '#639922', background: '#EAF3DE', padding: '2px 8px', borderRadius: 10 }}>✅ Завершён</span>
                    </div>
                    <div style={{ fontSize: 12, color: '#aaa', marginTop: 2 }}>
                      {c.passport} · {c.responsible_name || '—'}
                      {c.moscow_completed_at && <span> · {new Date(c.moscow_completed_at).toLocaleDateString('ru-RU')}</span>}
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button onClick={() => onOpenCandidate(c, 'moscow')} style={{ fontSize: 12, padding: '5px 12px', borderRadius: 6, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#444' }}>Открыть</button>
                    <button
                      onClick={async () => {
                        await updateCandidate(c.id, { moscow_completed: false, moscow_completed_at: null })
                        onRefresh()
                      }}
                      style={{ fontSize: 12, padding: '5px 12px', borderRadius: 6, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#888' }}
                    >↩ Вернуть</button>
                  </div>
                </div>
                <div style={{ borderTop: '1px solid #f0f0ec', marginTop: 10, paddingTop: 8 }}>
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 0', cursor: 'pointer' }}
                    onClick={async () => {
                      if (c.paid_by_contractors_at && !window.confirm(`Снять отметку «Оплачен контрагентами» с кандидата ${c.name}?`)) return
                      const val = c.paid_by_contractors_at ? null : new Date().toISOString()
                      await updateCandidate(c.id, { paid_by_contractors_at: val })
                      setExtraCandidates(prev => prev.map(x => x.id === c.id ? { ...x, paid_by_contractors_at: val } : x))
                    }}
                  >
                    <div style={{ width: 18, height: 18, borderRadius: 4, border: `1.5px solid ${c.paid_by_contractors_at ? '#3B6D11' : '#ccc'}`, background: c.paid_by_contractors_at ? '#3B6D11' : 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      {c.paid_by_contractors_at && <span style={{ color: 'white', fontSize: 11, lineHeight: 1 }}>✓</span>}
                    </div>
                    <span style={{ fontSize: 13, color: c.paid_by_contractors_at ? '#3B6D11' : '#888', flex: 1 }}>Оплачен контрагентами</span>
                    <span style={{ fontSize: 11, color: '#aaa' }}>{c.paid_by_contractors_at ? new Date(c.paid_by_contractors_at).toLocaleDateString('ru-RU') : '—'}</span>
                  </div>
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 0', cursor: 'pointer', borderTop: '1px solid #f0f0ec' }}
                    onClick={async () => {
                      if (c.paid_to_agent_at && !window.confirm(`Снять отметку «Оплатил агенту» с кандидата ${c.name}?`)) return
                      const val = c.paid_to_agent_at ? null : new Date().toISOString()
                      await updateCandidate(c.id, { paid_to_agent_at: val })
                      setExtraCandidates(prev => prev.map(x => x.id === c.id ? { ...x, paid_to_agent_at: val } : x))
                    }}
                  >
                    <div style={{ width: 18, height: 18, borderRadius: 4, border: `1.5px solid ${c.paid_to_agent_at ? '#185FA5' : '#ccc'}`, background: c.paid_to_agent_at ? '#185FA5' : 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      {c.paid_to_agent_at && <span style={{ color: 'white', fontSize: 11, lineHeight: 1 }}>✓</span>}
                    </div>
                    <span style={{ fontSize: 13, color: c.paid_to_agent_at ? '#185FA5' : '#888', flex: 1 }}>Оплатил агенту</span>
                    <span style={{ fontSize: 11, color: '#aaa' }}>{c.paid_to_agent_at ? new Date(c.paid_to_agent_at).toLocaleDateString('ru-RU') : '—'}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
{activeSection === 'partner_completed' && (
          <div>
            {extraLoading && <div style={{ textAlign: 'center', padding: 20, color: '#888', fontSize: 13 }}>Загрузка...</div>}
            <div style={{ fontSize: 13, color: '#888', marginBottom: 10 }}>
              Завершённые партнёрам — {myCandidates.filter(c => c.partner_completed).length} чел.
            </div>
            <input
              type="text"
              placeholder="Поиск по имени..."
              value={completedSearch}
              onChange={e => setCompletedSearch(e.target.value)}
              style={{ width: '100%', boxSizing: 'border-box', padding: '8px 12px', fontSize: 13, border: '1px solid #e0e0dc', borderRadius: 8, marginBottom: 8, outline: 'none' }}
            />
            {(() => {
              const allPartner = myCandidates.filter(c => c.partner_completed)
              const cntContractors = allPartner.filter(c => c.paid_by_contractors_at).length
              const cntAgent = allPartner.filter(c => c.paid_to_agent_at).length
              const cntNone = allPartner.filter(c => !c.paid_by_contractors_at && !c.paid_to_agent_at).length
              const cntNoAgent = allPartner.filter(c => !c.paid_to_agent_at).length
              const cntNoContractors = allPartner.filter(c => !c.paid_by_contractors_at).length
              const chipStyle = (key, color, bg, border) => ({
                fontSize: 12, padding: '5px 12px', borderRadius: 20, border: `1px solid ${completedPayFilter === key ? border : '#e0e0dc'}`,
                background: completedPayFilter === key ? bg : 'white', color: completedPayFilter === key ? color : '#888',
                cursor: 'pointer', whiteSpace: 'nowrap', fontWeight: completedPayFilter === key ? 600 : 400
              })
              return (
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 10 }}>
                  <span style={chipStyle('all', 'white', '#1a2332', '#1a2332')} onClick={() => setCompletedPayFilter('all')}>Все ({allPartner.length})</span>
                  <span style={chipStyle('contractors', '#3B6D11', '#EAF3DE', '#639922')} onClick={() => setCompletedPayFilter('contractors')}>✓ Оплачен контрагентами ({cntContractors})</span>
                  <span style={chipStyle('no_contractors', '#1a4d00', '#e8f5e2', '#388e3c')} onClick={() => setCompletedPayFilter('no_contractors')}>✗ Не оплатили контрагенты ({cntNoContractors})</span>
                  <span style={chipStyle('agent', '#0C447C', '#E6F1FB', '#185FA5')} onClick={() => setCompletedPayFilter('agent')}>✓ Оплатил агенту ({cntAgent})</span>
                  <span style={chipStyle('no_agent', '#7a1f00', '#fde8e4', '#d84315')} onClick={() => setCompletedPayFilter('no_agent')}>✗ Не оплатил агенту ({cntNoAgent})</span>
                  <span style={chipStyle('none', '#7a5000', '#fff3cd', '#e8a000')} onClick={() => setCompletedPayFilter('none')}>⏳ Не оплачен ({cntNone})</span>
                </div>
              )
            })()}
            {myCandidates.filter(c => c.partner_completed).length === 0 && (
              <div style={{ color: '#bbb', fontSize: 13, textAlign: 'center', padding: 32 }}>Нет завершённых партнёрам</div>
            )}
            {myCandidates.filter(c => {
              if (!c.partner_completed) return false
              if (completedSearch && !c.name.toLowerCase().includes(completedSearch.toLowerCase())) return false
              if (completedPayFilter === 'contractors') return !!c.paid_by_contractors_at
              if (completedPayFilter === 'no_contractors') return !c.paid_by_contractors_at
              if (completedPayFilter === 'agent') return !!c.paid_to_agent_at
              if (completedPayFilter === 'no_agent') return !c.paid_to_agent_at
              if (completedPayFilter === 'none') return !c.paid_by_contractors_at && !c.paid_to_agent_at
              return true
            }).map(c => (
              <div key={c.id} style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 10, padding: '12px 16px', marginBottom: 8 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <span style={{ fontWeight: 600, fontSize: 14 }}>{c.name}</span>
                      <span style={{ fontSize: 11, color: '#2e6da4', background: '#e8f0fe', padding: '2px 8px', borderRadius: 10 }}>🤝 Партнёрам</span>
                    </div>
                    <div style={{ fontSize: 12, color: '#aaa', marginTop: 2 }}>
                      {c.passport} · {c.responsible_name || '—'}
                      {c.partner_completed_at && <span> · {new Date(c.partner_completed_at).toLocaleDateString('ru-RU')}</span>}
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button onClick={() => onOpenCandidate(c, 'moscow')} style={{ fontSize: 12, padding: '5px 12px', borderRadius: 6, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#444' }}>Открыть</button>
                    <button
                      onClick={async () => {
                        await updateCandidate(c.id, { partner_completed: false, partner_completed_at: null })
                        onRefresh()
                      }}
                      style={{ fontSize: 12, padding: '5px 12px', borderRadius: 6, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#888' }}
                    >↩ Вернуть</button>
                  </div>
                </div>
                <div style={{ borderTop: '1px solid #f0f0ec', marginTop: 10, paddingTop: 8 }}>
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 0', cursor: 'pointer' }}
                    onClick={async () => {
                      if (c.paid_by_contractors_at && !window.confirm(`Снять отметку «Оплачен контрагентами» с кандидата ${c.name}?`)) return
                      const val = c.paid_by_contractors_at ? null : new Date().toISOString()
                      await updateCandidate(c.id, { paid_by_contractors_at: val })
                      setExtraCandidates(prev => prev.map(x => x.id === c.id ? { ...x, paid_by_contractors_at: val } : x))
                    }}
                  >
                    <div style={{ width: 18, height: 18, borderRadius: 4, border: `1.5px solid ${c.paid_by_contractors_at ? '#3B6D11' : '#ccc'}`, background: c.paid_by_contractors_at ? '#3B6D11' : 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      {c.paid_by_contractors_at && <span style={{ color: 'white', fontSize: 11, lineHeight: 1 }}>✓</span>}
                    </div>
                    <span style={{ fontSize: 13, color: c.paid_by_contractors_at ? '#3B6D11' : '#888', flex: 1 }}>Оплачен контрагентами</span>
                    <span style={{ fontSize: 11, color: '#aaa' }}>{c.paid_by_contractors_at ? new Date(c.paid_by_contractors_at).toLocaleDateString('ru-RU') : '—'}</span>
                  </div>
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 0', cursor: 'pointer', borderTop: '1px solid #f0f0ec' }}
                    onClick={async () => {
                      if (c.paid_to_agent_at && !window.confirm(`Снять отметку «Оплатил агенту» с кандидата ${c.name}?`)) return
                      const val = c.paid_to_agent_at ? null : new Date().toISOString()
                      await updateCandidate(c.id, { paid_to_agent_at: val })
                      setExtraCandidates(prev => prev.map(x => x.id === c.id ? { ...x, paid_to_agent_at: val } : x))
                    }}
                  >
                    <div style={{ width: 18, height: 18, borderRadius: 4, border: `1.5px solid ${c.paid_to_agent_at ? '#185FA5' : '#ccc'}`, background: c.paid_to_agent_at ? '#185FA5' : 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      {c.paid_to_agent_at && <span style={{ color: 'white', fontSize: 11, lineHeight: 1 }}>✓</span>}
                    </div>
                    <span style={{ fontSize: 13, color: c.paid_to_agent_at ? '#185FA5' : '#888', flex: 1 }}>Оплатил агенту</span>
                    <span style={{ fontSize: 11, color: '#aaa' }}>{c.paid_to_agent_at ? new Date(c.paid_to_agent_at).toLocaleDateString('ru-RU') : '—'}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
{activeSection === 'archive' && (
          <div>
            {extraLoading && <div style={{ textAlign: 'center', padding: 20, color: '#888', fontSize: 13 }}>Загрузка...</div>}
            {!extraLoading && (() => {
              const archiveBase = myCandidates.filter(c => c.archived && (!isAdmin || !respFilter || c.responsible_name === respFilter))
              return (<>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
                  <div style={{ fontSize: 13, color: '#888' }}>{isAdmin ? 'Все архивные кандидаты' : 'Мои архивные кандидаты'} ({archiveBase.length})</div>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Поиск по имени или паспорту..." style={{ fontSize: 13, padding: '5px 10px', borderRadius: 8, border: '1px solid #e0e0dc', minWidth: 220 }} />
                    {isAdmin && responsibleNames.length > 0 && (
                      <select value={respFilter} onChange={e => setRespFilter(e.target.value)} style={{ fontSize: 13, padding: '5px 10px', borderRadius: 8, border: '1px solid #e0e0dc' }}>
                        <option value="">Все ответственные</option>
                        {responsibleNames.map(n => <option key={n} value={n}>{n}</option>)}
                      </select>
                    )}
                  </div>
                </div>
                {archiveBase.filter(c => !search || c.name?.toLowerCase().includes(search.toLowerCase()) || c.passport?.toLowerCase().includes(search.toLowerCase())).length === 0 && <div style={{ color: '#bbb', fontSize: 13, textAlign: 'center', padding: 24 }}>Нет архивных кандидатов</div>}
                {archiveBase.filter(c => !search || c.name?.toLowerCase().includes(search.toLowerCase()) || c.passport?.toLowerCase().includes(search.toLowerCase())).map(c => (
              <div key={c.id} style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 10, padding: '12px 16px', marginBottom: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 14, color: '#888' }}>{c.name}</div>
                  <div style={{ fontSize: 12, color: '#aaa', marginTop: 2 }}>{c.passport} · {c.responsible_name || '—'}</div>
                  {c.archive_reason && <div style={{ fontSize: 11, color: '#E24B4A', marginTop: 4 }}>Причина: {c.archive_reason}</div>}
                </div>
                <div style={{ display: 'flex', gap: 6 }}>
                  {(isAdmin || isOperator) && onUnarchive && <button onClick={() => { if (window.confirm(`Восстановить ${c.name} из архива?`)) onUnarchive(c) }} style={{ fontSize: 12, padding: '4px 10px', borderRadius: 6, border: '1px solid #639922', background: '#EAF3DE', color: '#27500A', cursor: 'pointer' }}>Восстановить</button>}
                  <button onClick={() => onOpenCandidate(c)} style={{ fontSize: 12, padding: '4px 10px', borderRadius: 6, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer' }}>Открыть</button>
                </div>
              </div>
            ))}
              </>)
            })()}
          </div>
        )}

{activeSection === 'agent_advances' && isAdmin && (() => {
  const totalByAgent = {}
  agentAdvances.forEach(a => {
    const key = a.agent_name || 'Без агента'
    if (!totalByAgent[key]) totalByAgent[key] = {}
    const cur = a.currency || 'USD'
    totalByAgent[key][cur] = (totalByAgent[key][cur] || 0) + Number(a.amount)
  })
  return (
    <div>
      <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 16 }}>💵 Авансы агентам</div>
      {/* Форма добавления */}
      <div style={{ background: 'white', borderRadius: 12, padding: 20, marginBottom: 20, border: '1px solid #e8e8e5', maxWidth: 560 }}>
        <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 14 }}>Новый аванс</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <select value={advanceForm.agent_id} onChange={e => {
            const ag = agents.find(a => a.id === e.target.value)
            setAdvanceForm(f => ({ ...f, agent_id: e.target.value, agent_name: ag?.name || '' }))
          }} style={{ fontSize: 13, padding: '7px 10px', borderRadius: 8, border: '1px solid #e0e0dc' }}>
            <option value="">— выбери агента —</option>
            {agents.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
          </select>
          <div style={{ display: 'flex', gap: 8 }}>
            <input type="number" placeholder="Сумма" value={advanceForm.amount} onChange={e => setAdvanceForm(f => ({ ...f, amount: e.target.value }))}
              style={{ flex: 1, fontSize: 13, padding: '7px 10px', borderRadius: 8, border: '1px solid #e0e0dc' }} />
            <select value={advanceForm.currency} onChange={e => setAdvanceForm(f => ({ ...f, currency: e.target.value }))}
              style={{ fontSize: 13, padding: '7px 10px', borderRadius: 8, border: '1px solid #e0e0dc', width: 80 }}>
              <option>USD</option><option>RUB</option><option>EUR</option>
            </select>
          </div>
          <input placeholder="Комментарий" value={advanceForm.note} onChange={e => setAdvanceForm(f => ({ ...f, note: e.target.value }))}
            style={{ fontSize: 13, padding: '7px 10px', borderRadius: 8, border: '1px solid #e0e0dc' }} />
          <button disabled={advanceSaving || !advanceForm.agent_id || !advanceForm.amount} onClick={async () => {
            setAdvanceSaving(true)
            const added = await addAgentAdvance(advanceForm).catch(() => null)
            if (added) { setAgentAdvances(prev => [added, ...prev]); setAdvanceForm({ agent_id: '', agent_name: '', amount: '', currency: 'USD', note: '' }) }
            setAdvanceSaving(false)
          }} style={{ padding: '8px', borderRadius: 8, border: 'none', background: (!advanceForm.agent_id || !advanceForm.amount) ? '#ccc' : '#1a2332', color: 'white', fontWeight: 600, cursor: 'pointer', fontSize: 13 }}>
            {advanceSaving ? 'Сохранение...' : '+ Добавить аванс'}
          </button>
        </div>
      </div>
      {/* Итого по агентам */}
      {Object.keys(totalByAgent).length > 0 && (
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 20 }}>
          {Object.entries(totalByAgent).map(([name, byCur]) => (
            <div key={name} style={{ background: '#f0faf0', border: '1px solid #c8e6c9', borderRadius: 10, padding: '10px 16px' }}>
              <div style={{ fontWeight: 600, fontSize: 13 }}>{name}</div>
              {Object.entries(byCur).map(([cur, sum]) => (
                <div key={cur} style={{ fontSize: 14, fontWeight: 700, color: '#2e7d32' }}>{sum.toLocaleString('ru-RU')} {cur}</div>
              ))}
            </div>
          ))}
        </div>
      )}
      {/* Список авансов */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {agentAdvances.length === 0 && <div style={{ color: '#aaa', fontSize: 13 }}>Авансов пока нет</div>}
        {agentAdvances.map(a => (
          <div key={a.id} style={{ background: 'white', borderRadius: 10, padding: '12px 16px', border: '1px solid #e8e8e5', display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 600, fontSize: 13 }}>{a.agent_name || '—'}</div>
              <div style={{ fontSize: 12, color: '#888' }}>{new Date(a.created_at).toLocaleDateString('ru-RU')} · {a.created_by_name || ''}{a.note ? ` · ${a.note}` : ''}</div>
            </div>
            <div style={{ fontWeight: 700, fontSize: 15, color: '#1a6b3a', whiteSpace: 'nowrap' }}>{Number(a.amount).toLocaleString('ru-RU')} {a.currency}</div>
            <button onClick={async () => {
              if (!window.confirm('Удалить аванс?')) return
              await deleteAgentAdvance(a.id)
              setAgentAdvances(prev => prev.filter(x => x.id !== a.id))
            }} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ccc', fontSize: 16 }}>🗑</button>
          </div>
        ))}
      </div>
    </div>
  )
})()}

{activeSection === 'users' && isAdmin && (
          <div>
            <div style={{ fontSize: 13, color: '#888', marginBottom: 12 }}>Управление пользователями системы</div>
            {usersLoading && <div style={{ color: '#bbb', fontSize: 13 }}>Загрузка...</div>}
            {users.map(u => (
              <div key={u.id} style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 10, padding: '12px 16px', marginBottom: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>{u.full_name || '—'}</div>
                  <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{u.id}</div>
                </div>
                <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                  <select value={u.role || 'viewer'} onChange={async e => {
                    const newRole = e.target.value
                    try {
                      await updateUserProfile(u.id, { role: newRole })
                      setUsers(prev => prev.map(x => x.id === u.id ? { ...x, role: newRole } : x))
                    } catch(err) {
                      alert('Не удалось изменить роль: ' + err.message)
                    }
                  }} style={{ fontSize: 12, padding: '4px 8px', borderRadius: 6, border: '1px solid #e0e0dc' }}>
                    <option value="admin">Администратор</option>
                    <option value="operator">Оператор</option>
                    <option value="moscow_operator">Оператор Москва</option>
                    <option value="viewer">Просмотр</option>
                    <option value="external">Внешний</option>
                  </select>
                </div>
              </div>
            ))}
          </div>
        )}
        {activeSection === 'add_expense' && (
          <div>
            {entityToggle('add_expense')}
            {(sectionEntity['add_expense'] || 'candidate') === 'candidate' ? (
              <ExpenseInlineSection candidates={filteredCandidates.filter(c => !c.archived && c.status !== 'завершен' && !c.moscow_completed)} locations={locations} currentUserId={session?.user?.id} onRefresh={onRefresh} agents={agents} canSeeAgents={canSeeAgents} />
            ) : (
              <AgentExpenseSection agents={agents} onRefresh={() => fetchAgents().then(setAgents)} />
            )}
          </div>
        )}
        {activeSection === 'add_visa' && (
          <div>
            <VisaInlineSection candidates={filteredCandidates} locations={locations} onRefresh={onRefresh} />
          </div>
        )}
        {activeSection === 'locations' && (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
              <div style={{ fontSize: 13, color: '#888' }}>Кандидаты по локациям</div>
              {isAdmin && responsibleNames.length > 0 && (
                <select value={respFilter} onChange={e => setRespFilter(e.target.value)} style={{ fontSize: 13, padding: '5px 10px', borderRadius: 8, border: '1px solid #e0e0dc' }}>
                  <option value="">Все ответственные</option>
                  {responsibleNames.map(n => <option key={n} value={n}>{n}</option>)}
                </select>
              )}
            </div>
            {locations.map(l => {
              const inLocation = activeCandidates.filter(c => c.location_id === l.id && (!isAdmin || !respFilter || c.responsible_name === respFilter))
              return (
                <div key={l.id} style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 10, padding: '12px 16px', marginBottom: 10 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: inLocation.length > 0 ? 10 : 0 }}>
                    <div style={{ fontWeight: 600, fontSize: 14 }}>{l.icon} {l.name}</div>
                    <div style={{ fontSize: 13, color: '#888' }}>{inLocation.length} чел.</div>
                  </div>
                  {inLocation.length > 0 && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                      {inLocation.map(c => (
                        <div key={c.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 10px', background: '#fafaf8', borderRadius: 7, fontSize: 13 }}>
                          <div>
                            <span style={{ fontWeight: 500 }}>{c.name}</span>
                            <span style={{ color: '#aaa', fontSize: 11, marginLeft: 8 }}>{c.passport}</span>
                          </div>
                          <button onClick={() => onOpenCandidate(c)} style={{ fontSize: 11, padding: '3px 8px', borderRadius: 6, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#555' }}>Открыть</button>
                        </div>
                      ))}
                    </div>
                  )}
                  {inLocation.length === 0 && <div style={{ fontSize: 12, color: '#ccc' }}>Нет кандидатов</div>}
                </div>
              )
            })}
          </div>
        )}

        {activeSection === 'notifications' && (
          <div>
            <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 4 }}>🔔 Настройки уведомлений</h3>
            <NotificationSettings userProfile={userProfile} />
          </div>
        )}

        {activeSection === 'templates' && (
          <div>
            <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 16 }}>📋 Образцы документов и шаблоны</h3>
            <TemplatesPage isAdmin={isAdmin} uploaderName={userProfile?.full_name || 'Администратор'} />
          </div>
        )}

        {activeSection === 'tasks' && isAdmin && (() => {
          const visibleTasks = tasks.filter(t => {
            if (taskFilter === 'open' ? t.status !== 'open' : t.status !== 'done') return false
            if (!taskSearchQuery) return true
            const q = taskSearchQuery.toLowerCase()
            return (t.title || '').toLowerCase().includes(q) ||
              (t.description || '').toLowerCase().includes(q) ||
              (t.candidate_name || '').toLowerCase().includes(q) ||
              (t.candidate_phone || '').toLowerCase().includes(q)
          })
          const overdue = t => t.due_date && t.status === 'open' && new Date(t.due_date) < new Date(new Date().toDateString())
          const fmtDate = d => d ? new Date(d).toLocaleDateString('ru-RU') : null
          return (
            <div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10, flexWrap: 'wrap', gap: 8 }}>
                <h3 style={{ fontSize: 16, fontWeight: 700, margin: 0 }}>✅ Задачи</h3>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button onClick={() => setTaskFilter('open')} style={{ padding: '6px 14px', borderRadius: 8, border: '1px solid #e0e0dc', background: taskFilter === 'open' ? '#1a2332' : 'white', color: taskFilter === 'open' ? 'white' : '#444', fontSize: 13, cursor: 'pointer', fontWeight: taskFilter === 'open' ? 600 : 400 }}>Активные</button>
                  <button onClick={() => setTaskFilter('done')} style={{ padding: '6px 14px', borderRadius: 8, border: '1px solid #e0e0dc', background: taskFilter === 'done' ? '#1a2332' : 'white', color: taskFilter === 'done' ? 'white' : '#444', fontSize: 13, cursor: 'pointer', fontWeight: taskFilter === 'done' ? 600 : 400 }}>Завершённые</button>
                  <button onClick={() => setTaskFormOpen(f => !f)} style={{ padding: '6px 14px', borderRadius: 8, border: 'none', background: '#378ADD', color: 'white', fontSize: 13, cursor: 'pointer', fontWeight: 600 }}>+ Задача</button>
                </div>
              </div>
              <input
                value={taskSearchQuery}
                onChange={e => setTaskSearchQuery(e.target.value)}
                placeholder="🔍 Поиск по задачам, имени, телефону..."
                style={{ width: '100%', fontSize: 13, padding: '8px 12px', borderRadius: 8, border: '1px solid #e0e0dc', boxSizing: 'border-box', outline: 'none', marginBottom: 14 }}
              />

              {taskFormOpen && (
                <div style={{ background: 'white', border: '1px solid #e0e0dc', borderRadius: 12, padding: 16, marginBottom: 16 }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
                    <div style={{ gridColumn: '1/-1' }}>
                      <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Название*</div>
                      <input value={taskForm.title} onChange={e => setTaskForm(f => ({ ...f, title: e.target.value }))} placeholder="Что нужно сделать..." style={{ width: '100%', fontSize: 13, padding: '8px 10px', borderRadius: 8, border: '1px solid #e0e0dc', boxSizing: 'border-box', outline: 'none' }} />
                    </div>
                    <div style={{ gridColumn: '1/-1' }}>
                      <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Описание</div>
                      <textarea value={taskForm.description} onChange={e => setTaskForm(f => ({ ...f, description: e.target.value }))} rows={2} style={{ width: '100%', fontSize: 13, padding: '8px 10px', borderRadius: 8, border: '1px solid #e0e0dc', boxSizing: 'border-box', resize: 'vertical', fontFamily: 'inherit', outline: 'none' }} />
                    </div>
                    <div>
                      <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Дедлайн</div>
                      <input type="date" value={taskForm.due_date} onChange={e => setTaskForm(f => ({ ...f, due_date: e.target.value }))} style={{ width: '100%', fontSize: 13, padding: '8px 10px', borderRadius: 8, border: '1px solid #e0e0dc', boxSizing: 'border-box' }} />
                    </div>
                    <div>
                      <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Приоритет</div>
                      <select value={taskForm.priority} onChange={e => setTaskForm(f => ({ ...f, priority: e.target.value }))} style={{ width: '100%', fontSize: 13, padding: '8px 10px', borderRadius: 8, border: '1px solid #e0e0dc' }}>
                        <option value="normal">Обычный</option>
                        <option value="urgent">Срочный</option>
                      </select>
                    </div>
                    <div style={{ gridColumn: '1/-1', position: 'relative' }}>
                      <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Кандидат (необязательно)</div>
                      <input
                        value={taskForm.candidate_id ? taskForm.candidate_name : taskCandidateSearch}
                        onChange={e => { setTaskCandidateSearch(e.target.value); setTaskForm(f => ({ ...f, candidate_id: null, candidate_name: '' })); setTaskCandidateOpen(true) }}
                        onFocus={() => setTaskCandidateOpen(true)}
                        onBlur={() => setTimeout(() => setTaskCandidateOpen(false), 150)}
                        placeholder="Поиск кандидата..."
                        style={{ width: '100%', fontSize: 13, padding: '8px 10px', borderRadius: 8, border: `1px solid ${taskForm.candidate_id ? '#378ADD' : '#e0e0dc'}`, boxSizing: 'border-box', outline: 'none' }}
                      />
                      {taskForm.candidate_id && (
                        <button onClick={() => { setTaskForm(f => ({ ...f, candidate_id: null, candidate_name: '' })); setTaskCandidateSearch('') }}
                          style={{ position: 'absolute', right: 8, top: 28, background: 'none', border: 'none', cursor: 'pointer', color: '#aaa', fontSize: 14 }}>✕</button>
                      )}
                      {taskCandidateOpen && !taskForm.candidate_id && (() => {
                        const q = taskCandidateSearch.toLowerCase()
                        const filtered = myCandidates.filter(c => !c.archived && c.name.toLowerCase().includes(q)).slice(0, 20)
                        if (!filtered.length) return null
                        return (
                          <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'white', border: '1px solid #e0e0dc', borderRadius: 8, boxShadow: '0 4px 16px rgba(0,0,0,0.12)', zIndex: 100, maxHeight: 160, overflowY: 'auto', marginTop: 2 }}
                            onMouseDown={e => e.preventDefault()}>
                            {filtered.map(c => (
                              <div key={c.id} onClick={() => { setTaskForm(f => ({ ...f, candidate_id: c.id, candidate_name: c.name })); setTaskCandidateSearch(''); setTaskCandidateOpen(false) }}
                                style={{ padding: '8px 12px', cursor: 'pointer', fontSize: 13, borderBottom: '0.5px solid #f5f5f3' }}
                                onMouseEnter={e => e.currentTarget.style.background = '#f5f5f3'}
                                onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                                {c.name} {c.citizenship ? <span style={{ color: '#aaa', fontSize: 11 }}>· {c.citizenship}</span> : null}
                              </div>
                            ))}
                          </div>
                        )
                      })()}
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button onClick={handleAddTask} disabled={taskSaving || !taskForm.title.trim()} style={{ flex: 1, padding: '8px', borderRadius: 8, border: 'none', background: taskForm.title.trim() ? '#1a2332' : '#ccc', color: 'white', cursor: taskForm.title.trim() ? 'pointer' : 'default', fontSize: 13, fontWeight: 600 }}>{taskSaving ? 'Сохранение...' : 'Добавить'}</button>
                    <button onClick={() => setTaskFormOpen(false)} style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', fontSize: 13 }}>Отмена</button>
                  </div>
                </div>
              )}

              {tasksLoading ? <div style={{ color: '#aaa', fontSize: 13 }}>Загрузка...</div> : visibleTasks.length === 0 ? (
                <div style={{ color: '#aaa', fontSize: 13, textAlign: 'center', padding: 32 }}>{taskFilter === 'open' ? 'Нет активных задач' : 'Нет завершённых задач'}</div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }} onClick={() => setTaskMenuId(null)}>
                  {[...visibleTasks].sort((a, b) => (b.pinned ? 1 : 0) - (a.pinned ? 1 : 0)).map(task => (
                    <div key={task.id} style={{ background: task.pinned ? '#fffbf0' : 'white', border: `1px solid ${task.pinned ? '#f0d080' : overdue(task) ? '#ffcdd2' : '#e8e8e5'}`, borderLeft: `4px solid ${task.pinned ? '#f0c040' : task.priority === 'urgent' ? '#E24B4A' : overdue(task) ? '#EF9F27' : '#e0e0dc'}`, borderRadius: 10, padding: '12px 14px', display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                      <button onClick={() => task.status === 'open' ? handleCompleteTask(task) : handleReopenTask(task)}
                        style={{ width: 22, height: 22, borderRadius: '50%', border: `2px solid ${task.status === 'done' ? '#639922' : '#ccc'}`, background: task.status === 'done' ? '#639922' : 'white', cursor: 'pointer', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 1 }}>
                        {task.status === 'done' && <span style={{ color: 'white', fontSize: 12, fontWeight: 700 }}>✓</span>}
                      </button>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        {taskEditingId === task.id ? (
                          <div>
                            <input value={taskEditForm.title} onChange={e => setTaskEditForm(f => ({ ...f, title: e.target.value }))}
                              style={{ width: '100%', fontSize: 13, padding: '5px 8px', borderRadius: 6, border: '1px solid #378ADD', outline: 'none', marginBottom: 6, boxSizing: 'border-box' }} />
                            <textarea value={taskEditForm.description} onChange={e => setTaskEditForm(f => ({ ...f, description: e.target.value }))} rows={2}
                              style={{ width: '100%', fontSize: 12, padding: '5px 8px', borderRadius: 6, border: '1px solid #e0e0dc', outline: 'none', resize: 'vertical', fontFamily: 'inherit', marginBottom: 6, boxSizing: 'border-box' }} placeholder="Описание..." />
                            <div style={{ display: 'flex', gap: 6, marginBottom: 6 }}>
                              <input type="date" value={taskEditForm.due_date} onChange={e => setTaskEditForm(f => ({ ...f, due_date: e.target.value }))}
                                style={{ fontSize: 12, padding: '4px 8px', borderRadius: 6, border: '1px solid #e0e0dc', flex: 1 }} />
                              <select value={taskEditForm.priority} onChange={e => setTaskEditForm(f => ({ ...f, priority: e.target.value }))}
                                style={{ fontSize: 12, padding: '4px 8px', borderRadius: 6, border: '1px solid #e0e0dc' }}>
                                <option value="normal">Обычный</option>
                                <option value="urgent">Срочный</option>
                              </select>
                            </div>
                            <div style={{ display: 'flex', gap: 6 }}>
                              <button onClick={() => handleSaveEditTask(task)} style={{ fontSize: 12, padding: '4px 12px', borderRadius: 6, border: 'none', background: '#1a2332', color: 'white', cursor: 'pointer' }}>Сохранить</button>
                              <button onClick={() => setTaskEditingId(null)} style={{ fontSize: 12, padding: '4px 12px', borderRadius: 6, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer' }}>Отмена</button>
                            </div>
                          </div>
                        ) : (
                          <>
                            <div style={{ fontWeight: 600, fontSize: 14, textDecoration: task.status === 'done' ? 'line-through' : 'none', color: task.status === 'done' ? '#aaa' : '#1a2332' }}>
                              {task.pinned && <span style={{ fontSize: 11, marginRight: 4 }}>📌</span>}{task.title}
                            </div>
                            {task.description && <div style={{ fontSize: 12, color: '#888', marginTop: 3 }}>{task.description}</div>}
                            <div style={{ display: 'flex', gap: 10, marginTop: 5, flexWrap: 'wrap' }}>
                              {task.due_date && <span style={{ fontSize: 11, color: overdue(task) ? '#E24B4A' : '#aaa' }}>{overdue(task) ? '⚠ ' : ''}Дедлайн: {fmtDate(task.due_date)}</span>}
                              {task.priority === 'urgent' && <span style={{ fontSize: 11, color: '#E24B4A', fontWeight: 600 }}>🔴 Срочно</span>}
                              {task.candidate_name && task.candidate_id && (
                                <span onClick={() => { const c = myCandidates.find(x => x.id === task.candidate_id); if (c) onOpenCandidate(c) }}
                                  style={{ fontSize: 11, color: '#378ADD', cursor: 'pointer', textDecoration: 'underline' }}>👤 {task.candidate_name}</span>
                              )}
                              {task.candidate_phone && (
                                <span style={{ fontSize: 11, color: '#888' }}>📞 {task.candidate_phone}</span>
                              )}
                              {task.status === 'done' && task.completed_at && <span style={{ fontSize: 11, color: '#aaa' }}>Завершена {fmtDate(task.completed_at)}</span>}
                              {task.created_by_name && isAdmin && userProfile?.full_name === 'Анна' && <span style={{ fontSize: 11, color: '#aaa' }}>от {task.created_by_name}</span>}
                            </div>
                          </>
                        )}
                      </div>
                      <div style={{ position: 'relative', flexShrink: 0 }}>
                        <button onClick={e => { e.stopPropagation(); setTaskMenuId(taskMenuId === task.id ? null : task.id) }}
                          style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#bbb', fontSize: 18, padding: '0 4px', lineHeight: 1 }}>⋯</button>
                        {taskMenuId === task.id && (
                          <div onClick={e => e.stopPropagation()} style={{ position: 'absolute', right: 0, top: 22, background: 'white', border: '1px solid #e0e0dc', borderRadius: 8, boxShadow: '0 4px 16px rgba(0,0,0,0.12)', zIndex: 10, minWidth: 150, overflow: 'hidden' }}>
                            <button onClick={() => { setTaskEditForm({ title: task.title, description: task.description || '', due_date: task.due_date ? task.due_date.slice(0,10) : '', priority: task.priority || 'normal' }); setTaskEditingId(task.id); setTaskMenuId(null) }}
                              style={{ display: 'block', width: '100%', textAlign: 'left', padding: '9px 14px', border: 'none', background: 'none', cursor: 'pointer', fontSize: 13, color: '#333' }}>✏ Редактировать</button>
                            <button onClick={() => handlePinTask(task)}
                              style={{ display: 'block', width: '100%', textAlign: 'left', padding: '9px 14px', border: 'none', background: 'none', cursor: 'pointer', fontSize: 13, color: task.pinned ? '#c07840' : '#333', borderTop: '1px solid #f5f5f5' }}>
                              {task.pinned ? '📌 Открепить' : '📌 Закрепить'}</button>
                            <button onClick={() => { setTaskMenuId(null); handleDeleteTask(task) }}
                              style={{ display: 'block', width: '100%', textAlign: 'left', padding: '9px 14px', border: 'none', background: 'none', cursor: 'pointer', fontSize: 13, color: '#E24B4A', borderTop: '1px solid #f5f5f5' }}>🗑 Удалить</button>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )
        })()}
      </div>
    </div>
  )
}